const data = 

{
  status: 1,
  data: [
    {
      questionDisplay: "Is waste collected from your household/shop on a daily basis?",
      optionType: "Single choice",
     optionValues: [
        {
          option_value: "HH",
          option_display: "Yes, from Household"
        },
        {
          option_value: "CCP",
          option_display: "Yes, from common collection points"
        },
        {
          option_value: "DD",
          option_display: "Yes, collected daily but specific types of waste are collected on designated days"
        },
        {
          option_value: "N",
          option_display: "No"
        }
      ],
      questionCode: "FQ1",
      questionId: 1,
      questionDisplayOrder: 1,
      languages: {
        hi: {
          questionDisplay: "क्या आपके घर/दुकान से रोज़ाना कचरा उठाया जाता है?",
         optionValues: [
            {
              option_value: "HH",
              option_display: "हाँ, घर से"
            },
            {
              option_value: "CCP",
              option_display: "हाँ, कॉमन कलेक्शन पॉइंट से"
            },
            {
              option_value: "DD",
              option_display: "हाँ, रोज़ाना उठाया जाता है लेकिन खास तरह का कचरा तय दिनों पर उठाया जाता है"
            },
            {
              option_value: "N",
              option_display: "नहीं"
            }
          ]
        },
         pa: {
          questionDisplay: "ਕੀ ਤੁਹਾਡੇ ਘਰ/ਦੁਕਾਨ ਤੋਂ ਰੋਜ਼ਾਨਾ ਕੂੜਾ ਇਕੱਠਾ ਕੀਤਾ ਜਾਂਦਾ ਹੈ?",
         optionValues: [
            {
              option_value: "HH",
              option_display: "ਹਾਂ, ਘਰ ਤੋਂ"
            },
            {
              option_value: "CCP",
              option_display: "ਹਾਂ, ਸਾਂਝੇ ਸੰਗ੍ਰਹਿ ਸਥਾਨਾਂ ਤੋਂ"
            },
            {
              option_value: "DD",
              option_display: "ਹਾਂ, ਰੋਜ਼ਾਨਾ ਇਕੱਠਾ ਕੀਤਾ ਜਾਂਦਾ ਹੈ ਪਰ ਖਾਸ ਕਿਸਮ ਦਾ ਕੂੜਾ ਨਿਰਧਾਰਤ ਦਿਨਾਂ 'ਤੇ ਇਕੱਠਾ ਕੀਤਾ ਜਾਂਦਾ ਹੈ"
            },
            {
              option_value: "N",
              option_display: "ਨਹੀਂ"
            }
          ]
        },
        te: {
          questionDisplay: "మీ ఇంటి నుండి/ దుకాణం నుండి ప్రతిరోజూ చెత్తను సేకరిస్తున్నారా?",
         optionValues: [
            {
              option_value: "HH",
              option_display: "అవును, ఇంటి నుండి"
            },
            {
              option_value: "CCP",
              option_display: "అవును, కామన్ కలెక్షన్ పాయింట్ నుండి"
            },
            {
              option_value: "DD",
              option_display: "అవును, ప్రతిరోజూ సేకరిస్తారు, అయితే కొన్ని ప్రత్యేక రకాల చెత్తను నిర్ణీత రోజులలో మాత్రమే సేకరిస్తారు."
            },
            {
              option_value: "N",
              option_display: "లేదు"
            }
          ]
        },
       as: {
          questionDisplay: "আপোনাৰ ঘৰ/দোকানৰ পৰা দৈনিক আৱৰ্জনা সংগ্ৰহ কৰা হয় নেকি?",
         optionValues: [
            {
              option_value: "HH",
              option_display: "হয়, ঘৰৰ পৰা"
            },
            {
              option_value: "CCP",
              option_display: "হয়, সাধাৰণ সংগ্ৰহ পইন্টৰ পৰা"
            },
            {
              option_value: "DD",
              option_display: "হয়, দৈনিক সংগ্ৰহ কৰা হয় কিন্তু নিৰ্দিষ্ট ধৰণৰ আৱৰ্জনা নিৰ্দিষ্ট দিনত সংগ্ৰহ কৰা হয়"
            },
            {
              option_value: "N",
              option_display: "নহয়"
            }
          ]
        },
        or: {
          questionDisplay: "ଆପଣଙ୍କ ଘର/ଦୋକାନରୁ ପ୍ରତିଦିନ ଅଳିଆ ସଂଗ୍ରହ କରାଯାଏ କି?",
         optionValues: [
            {
              option_value: "HH",
              option_display: "ହଁ, ପରିବାରରୁ"
            },
            {
              option_value: "CCP",
              option_display: "ହଁ, ସାଧାରଣ ସଂଗ୍ରହ ସ୍ଥାନରୁ"
            },
            {
              option_value: "DD",
              option_display: "ହଁ, ପ୍ରତିଦିନ ସଂଗ୍ରହ କରାଯାଏ କିନ୍ତୁ ନିର୍ଦ୍ଦିଷ୍ଟ ପ୍ରକାରର ଅଳିଆ ନିର୍ଦ୍ଦିଷ୍ଟ ଦିନରେ ସଂଗ୍ରହ କରାଯାଏ।"
            },
            {
              option_value: "N",
              option_display: "ନା"
            }
          ]
        },
       mr: {
          questionDisplay: "तुमच्या घरातून/ दुकानातून दररोज कचरा गोळा केला जातो का?",
         optionValues: [
            {
              option_value: "HH",
              option_display: "होय, घरातून गोळा केला जातो"
            },
            {
              option_value: "CCP",
              option_display: "होय, कचरा गोळा करण्याच्या ठराविक ठिकाणाहून गोळा केला जातो"
            },
            {
              option_value: "DD",
              option_display: "होय, दररोज गोळा केला जातो परंतु विशिष्ट प्रकारचा कचरा ठराविक दिवशी गोळा केला जातो"
            },
            {
              option_value: "N",
              option_display: "नाही"
            }
          ]
        },
      ka: {
          questionDisplay: "ನಿಮ್ಮ ಮನೆ/ದukkanದಿಂದ ಕಸದ ಸಂಗ್ರಹಣೆ ಪ್ರತಿದಿನವಾಗಿಯೇ ನಡೆಯುತ್ತದೆಯೆ?",
         optionValues: [
            {
              option_value: "HH",
              option_display: "ಹೌದು, ಮನೆಮಠದಿಂದ"
            },
            {
              option_value: "CCP",
              option_display: "ಹೌದು, ಸಾಮೂಹಿಕ ಸಂಗ್ರಹಣೆ ಕೇಂದ್ರಗಳಿಂದ"
            },
            {
              option_value: "DD",
              option_display: "ಹೌದು, ದಿನನಿತ್ಯ ಸಂಗ್ರಹಣೆ ನಡೆಯುತ್ತದೆ ಆದರೆ ಕೆಲವು ವಿಧಗಳ ಕಸವನ್ನು ನಿಗದಿತ ದಿನಗಳಲ್ಲಿ ಮಾತ್ರ ಸಂಗ್ರಹಿಸಲಾಗುತ್ತದೆ"
            },
            {
              option_value: "N",
              option_display: "ಇಲ್ಲ"
            }
          ]
        },
       bn: {
          questionDisplay: "আপনার বাড়ি/ দোকান থেকে কি প্রতিদিন ময়লা সংগ্রহ করা হয়?",
         optionValues: [
            {
              option_value: "HH",
              option_display: "হ্যাঁ, বাড়ি থেকে"
            },
            {
              option_value: "CCP",
              option_display: "হ্যাঁ, সাধারন সংগ্রহ করার স্থান থেকে"
            },
            {
              option_value: "DD",
              option_display: "হ্যাঁ, প্রতিদিন সংগ্রহ করা হয় কিন্তু নির্দিষ্ট ধরনের আবর্জনা নির্দিষ্ট দিনে সংগ্রহ করা হয়"
            },
            {
              option_value: "N",
              option_display: "না"
            }
          ]
        },
       ta: {
          questionDisplay: "உங்கள் வீடு அல்லது கடையிலிருந்து அன்றாட அடிப்படையில் குப்பைகள்  சேகரிக்கப்படுகின்றனவா?",
         optionValues: [
            {
              option_value: "HH",
              option_display: "ஆம், வீட்டிலிருந்து"
            },
            {
              option_value: "CCP",
              option_display: "ஆம், பொதுவான சேகரிப்பு இடங்களில் இருந்து"
            },
            {
              option_value: "DD",
              option_display: "ஆம், தினமும் சேகரிக்கப்படுகிறது ஆனால் குறிப்பிட்ட வகையான கழிவு அதற்கான ஒதுக்கப்பட்ட நாட்களில் சேரிக்கப்படுகின்றன"
            },
            {
              option_value: "N",
              option_display: "இல்லை"
            }
          ]
        },
        ur: {
          questionDisplay: "کیا آپ کے گھر / دکان سے روزانہ کی بنیاد پر کچرا جمع کیا جاتا ہے",
         optionValues: [
            {
              option_value: "HH",
              option_display: "جی ہاں، گھر سے"
            },
            {
              option_value: "CCP",
              option_display: "جی ہاں، مشترکہ جمع کرنے کے مقامات سے"
            },
            {
              option_value: "DD",
              option_display: "جی ہاں، روزانہ جمع کیا جاتا ہے لیکن مخصوص اقسام کا کچرا مقررہ دنوں میں جمع کیا جاتا ہےs"
            },
            {
              option_value: "N",
              option_display: "نہیں"
            }
          ]
        },
        gu: {
          questionDisplay: "શું તમારા ઘર/દુકાનમાંથી દરરોજ કચરો એકત્રિત કરવામાં આવે છે?",
         optionValues: [
            {
              option_value: "HH",
              option_display: "હા, ઘરમાંથી"
            },
            {
              option_value: "CCP",
              option_display: "હા, સામાન્ય કલેક્શન પોઈન્ટ પરથી"
            },
            {
              option_value: "DD",
              option_display: "હા, દરરોજ એકત્રિત કરવામાં આવે છે પણ ચોક્કસ પ્રકારનો કચરો ચોક્કસ દિવસોમાં એકત્રિત કરવામાં આવે છે."
            },
            {
              option_value: "N",
              option_display: "ના"
            }
          ]
        },
        ml: {
          questionDisplay: "നിങ്ങളുടെ വീട്ടിൽ നിന്നോ/കടയിൽ നിന്നോ ദിവസേന മാലിന്യം ശേഖരിക്കാറുണ്ടോ?",
         optionValues: [
            {
              option_value: "HH",
              option_display: "അതെ, വീടുകളിൽ നിന്ന്"
            },
            {
              option_value: "CCP",
              option_display: "അതെ, പൊതു ശേഖരണ കേന്ദ്രങ്ങളിൽ നിന്ന്"
            },
            {
              option_value: "DD",
              option_display: "അതെ, ദിവസേന ശേഖരിക്കും, പക്ഷേ പ്രത്യേക തരം മാലിന്യങ്ങൾ നിശ്ചിത ദിവസങ്ങളിൽ ശേഖരിക്കും"
            },
            {
              option_value: "N",
              option_display: "ഇല്ല"
            }
          ]
        }
      }
    },
    {
      questionDisplay: "Does your household / shop segregate waste at least into dry and wet categories before disposal?",
      optionType: "Single choice",
     optionValues: [
        {
          option_value: "YA",
          option_display: "Yes, always"
        },
        {
          option_value: "YS",
          option_display: "Yes, sometimes"
        },
        {
          option_value: "NU",
          option_display: "No, Unaware of Segregation"
        },
        {
          option_value: "AD",
          option_display: "Aware but do not segregate waste"
        }
      ],
      questionCode: "FQ2",
      questionId: 2,
      questionDisplayOrder: 2,
      languages: {
        hi: {
          questionDisplay: "क्या आपका घर/दुकान कचरे को फेंकने से पहले कम से कम सूखे और गीले कचरे को अलग-अलग करता है?",
         optionValues: [
            {
              option_value: "YA",
              option_display: "हाँ हमेशा"
            },
            {
              option_value: "YS",
              option_display: "हाँ, कभी-कभी"
            },
            {
              option_value: "NU",
              option_display: "नहीं, अलग-अलग करने के बारे में नहीं जानते"
            },
            {
              option_value: "AD",
              option_display: "जानते हैं लेकिन कचरा अलग नहीं करते"
            }
          ]
        },
         pa: {
          questionDisplay: "ਕੀ ਤੁਹਾਡਾ ਘਰ/ਦੁਕਾਨ ਕੂੜੇ ਨੂੰ ਨਿਪਟਾਰੇ ਤੋਂ ਪਹਿਲਾਂ ਘੱਟੋ-ਘੱਟ ਸੁੱਕੇ ਅਤੇ ਗਿੱਲੇ ਵਰਗਾਂ ਵਿੱਚ ਵੱਖਰਾ ਕਰਦਾ ਹੈ?",
         optionValues: [
            {
              option_value: "YA",
              option_display: "ਹਾਂ, ਹਮੇਸ਼ਾ"
            },
            {
              option_value: "YS",
              option_display: "ਹਾਂ, ਕਈ ਵਾਰ"
            },
            {
              option_value: "NU",
              option_display: "ਨਹੀਂ, ਅਲੱਗ-ਥਲੱਗ ਕਰਨ ਤੋਂ ਅਣਜਾਣ"
            },
            {
              option_value: "AD",
              option_display: "ਜਾਣੂ ਹਾਂ ਪਰ ਕੂੜੇ ਨੂੰ ਵੱਖ ਨਾ ਕਰੋ"
            }
          ]
        },
        te: {
          questionDisplay: "మీ ఇంట్లో / దుకాణంలో చెత్తను పారవేసే ముందు కనీసం పొడిచెత్త మరియు పొడిచెత్త అని వేరు వేరు చేస్తారా?",
         optionValues: [
            {
              option_value: "YA",
              option_display: "అవును, ఎల్లప్పుడూ"
            },
            {
              option_value: "YS",
              option_display: "అవును, కొన్నిసార్లు"
            },
            {
              option_value: "NU",
              option_display: "లేదు, అలా వేరు చేయడం గురించి తెలియదు"
            },
            {
              option_value: "AD",
              option_display: "తెలుసు కానీ చెత్త/ వ్యర్థాలను వేరు చేయము"
            }
          ]
        },
       as: {
          questionDisplay: "আপোনাৰ ঘৰ/দোকানত নিষ্পত্তি কৰাৰ আগতে আৱৰ্জনাবোৰ অন্ততঃ শুকান আৰু ভিজা শ্ৰেণীত পৃথক কৰে নেকি?",
         optionValues: [
            {
              option_value: "YA",
              option_display: "হয়, সদায়"
            },
            {
              option_value: "YS",
              option_display: "হয়, কেতিয়াবা"
            },
            {
              option_value: "NU",
              option_display: "নহয়, পৃথকীকৰণৰ বিষয়ে অজ্ঞাত"
            },
            {
              option_value: "AD",
              option_display: "সচেতন হয় কিন্তু আৱৰ্জনা পৃথক নকৰে"
            }
          ]
        },
        or: {
          questionDisplay: "ଆପଣଙ୍କ ପରିବାର / ଦୋକାନ କ’ଣ ଡିସପୋଜ କରିବା ପୂର୍ବରୁ ଅଳିଆକୁ ଅତି କମରେ ଶୁଖିଲା ଏବଂ ଓଦା ବର୍ଗରେ ପୃଥକ କରେ?",
         optionValues: [
            {
              option_value: "YA",
              option_display: "ହଁ, ସର୍ବଦା"
            },
            {
              option_value: "YS",
              option_display: "ହଁ, ବେଳେବେଳେ "
            },
            {
              option_value: "NU",
              option_display: "ନା, ପୃଥକୀକରଣ ବିଷୟରେ ଅଜ୍ଞ"
            },
            {
              option_value: "AD",
              option_display: "ସଚେତନ କିନ୍ତୁ ଅଳିଆ ପୃଥକ କରନ୍ତି  ନାହିଁ"
            }
          ]
        },
       mr: {
          questionDisplay: "तुम्ही तुमच्या घरातील/दुकानातील कचरा फेकण्याआधी किमान तो सुका आणि ओला असे वेगळा करता का?",
         optionValues: [
            {
              option_value: "YA",
              option_display: "होय, नेहमीच"
            },
            {
              option_value: "YS",
              option_display: "होय, कधीकधी"
            },
            {
              option_value: "NU",
              option_display: "नाही, वेगळे करण्याविषयी माहित नाही"
            },
            {
              option_value: "AD",
              option_display: "माहित आहे परंतु कचरा वेगळा करत नाही"
            }
          ]
        },
      ka: {
          questionDisplay: "ನಿಮ್ಮ ಮನೆ/ದukkanದಲ್ಲಿ ಕಸವನ್ನು ತ್ಯಾಜ್ಯಕ್ಕೆ ಹಾಕುವುದಕ್ಕೂ ಮುಂಚೆ ಒಣ ಮತ್ತು ತೇವವಾಗಿ ವಿಭಜಿಸುತ್ತೀರಾ?",
         optionValues: [
            {
              option_value: "YA",
              option_display: "ಹೌದು, ಯಾವಾಗಲೂ"
            },
            {
              option_value: "YS",
              option_display: "ಹೌದು, ಕೆಲವೊಮ್ಮೆ"
            },
            {
              option_value: "NU",
              option_display: "ಇಲ್ಲ, ವಿಭಜನೆ ಬಗ್ಗೆ ತಿಳಿದಿಲ್ಲ"
            },
            {
              option_value: "AD",
              option_display: "ತಿಳಿದಿದ್ದರೂ ವಿಭಜಿಸುವುದಿಲ್ಲ"
            }
          ]
        },
       bn: {
          questionDisplay: "আপনার বাড়িতে/ দোকানে কি আবর্জনাকে অন্তত শুকনো এবং পচনশীল আবর্জনায় ভাগ করেন?",
         optionValues: [
            {
              option_value: "YA",
              option_display: "হ্যাঁ, সবসময়"
            },
            {
              option_value: "YS",
              option_display: "হ্যাঁ, মাঝে-মধ্যে"
            },
            {
              option_value: "NU",
              option_display: "না, আলাদা করার ব্যাপারে জানা নেই"
            },
            {
              option_value: "AD",
              option_display: "জানেন কিন্তু আবর্জনা আলাদা করে না"
            }
          ]
        },
       ta: {
          questionDisplay: "உங்கள் வீடு அல்லது கடை கழிவுகளை அகற்றுவதற்கு முன், குறைந்தபட்சம் உலர்ந்த மற்றும் ஈரக் கழிவுகள் என பிரித்து வைக்கிறதா?",
         optionValues: [
            {
              option_value: "YA",
              option_display: "ஆம், எப்பொழுதும்"
            },
            {
              option_value: "YS",
              option_display: "ஆம், சில சமயங்களில்"
            },
            {
              option_value: "NU",
              option_display: "இல்லை, பிரிப்பதை பற்றி அறியவில்லை"
            },
            {
              option_value: "AD",
              option_display: "அறிந்துள்ளேன் ஆனால் கழிவுகளை பிரிப்பதில்லை"
            }
          ]
        },
        ur: {
          questionDisplay: "کیا آپ کا گھر / دکان کچرے کو ٹھکانے لگانے سے پہلے کم از کم خشک اور گیلی اقسام میں الگ کرتا ہے",
         optionValues: [
            {
              option_value: "YA",
              option_display: "جی ہاں، ہمیشہ"
            },
            {
              option_value: "YS",
              option_display: "جی ہاں، کبھی کبھار"
            },
            {
              option_value: "NU",
              option_display: "نہیں، علیحدگی کے بارے میں آگاہی نہیں ہے"
            },
            {
              option_value: "AD",
              option_display: "آگاہ ہیں لیکن کچرا الگ نہیں کرتے"
            }
          ]
        },
        gu: {
          questionDisplay: "શું તમારા ઘર / દુકાનમાં કચરો નિકાલ કરતા પહેલા તેને ઓછામાં ઓછા સૂકા અને ભીના કચરામાં અલગ કરવામાં આવે છે?",
         optionValues: [
            {
              option_value: "YA",
              option_display: "હા, હંમેશા"
            },
            {
              option_value: "YS",
              option_display: "હા, કેટલીકવાર"
            },
            {
              option_value: "NU",
              option_display: "ના, અલગ કરવા વિશે જાણતા નથી"
            },
            {
              option_value: "AD",
              option_display: "જાણે છે પણ અલગ કરતા નથી"
            }
          ]
        },
        ml: {
          questionDisplay: "നിങ്ങളുടെ വീട്ടിലെയോ കടയിലെയോ മാലിന്യങ്ങൾ സംസ്‌കരിക്കുന്നതിന് മുമ്പ് ഉണങ്ങിയതും നനഞ്ഞതുമായ വിഭാഗങ്ങളായി വേർതിരിക്കാറുണ്ടോ?",
         optionValues: [
            {
              option_value: "YA",
              option_display: "അതെ, എപ്പോഴും"
            },
            {
              option_value: "YS",
              option_display: "അതെ, ചിലപ്പോൾ"
            },
            {
              option_value: "NU",
              option_display: "ഇല്ല, വേർതിരിക്കലിനെക്കുറിച്ച് അറിയില്ല"
            },
            {
              option_value: "AD",
              option_display: "അറിയുന്നു, പക്ഷേ മാലിന്യങ്ങൾ വേർതിരിക്കുന്നില്ല"
            }
          ]
        }
      }
    },
    {
      questionDisplay: "Does the waste collector collect and load waste into the vehicle in a segregated manner (by category), or is it mixed during collection/loading?",
      optionType: "Single choice",
     optionValues: [
        {
          option_value: "SEG",
          option_display: "Waste is collected and loaded separately by category (segregated)"
        },
        {
          option_value: "MIX_LOAD",
          option_display: "Waste is collected separately but mixed during loading"
        },
        {
          option_value: "MIX",
          option_display: "Waste is collected and loaded in mixed form"
        }
      ],
      questionCode: "FQ3",
      questionId: 3,
      questionDisplayOrder: 3,
      languages: {
        hi: {
          questionDisplay: "क्या कचरा उठाने वाला कचरा अलग-अलग तरीके से (कैटेगरी के अनुसार) उठाकर गाड़ी में डालता है, या उठाने/लोड करने के दौरान उसे मिला देता है?",
         optionValues: [
            {
              option_value: "SEG",
              option_display: "कचरे को कैटेगरी के अनुसार अलग-अलग उठाया और लोड किया जाता है (अलग किया जाता है)"
            },
            {
              option_value: "MIX_LOAD",
              option_display: "कचरा अलग-अलग उठाया जाता है लेकिन लोडिंग के दौरान मिला दिया जाता है"
            },
            {
              option_value: "MIX",
              option_display: "कचरे को एक साथ मिलाकर उठाया और लोड किया जाता है"
            }
          ]
        },
         pa: {
          questionDisplay: "ਕੀ ਕੂੜਾ ਇਕੱਠਾ ਕਰਨ ਵਾਲਾ ਕੂੜਾ ਵੱਖਰਾ ਢੰਗ ਨਾਲ (ਸ਼੍ਰੇਣੀ ਅਨੁਸਾਰ) ਇਕੱਠਾ ਕਰਦਾ ਹੈ ਅਤੇ ਵਾਹਨ ਵਿੱਚ ਲੋਡ ਕਰਦਾ ਹੈ, ਜਾਂ ਕੀ ਇਸਨੂੰ ਇਕੱਠਾ ਕਰਨ/ਲੋਡ ਕਰਨ ਦੌਰਾਨ ਮਿਲਾਇਆ ਜਾਂਦਾ ਹੈ?",
         optionValues: [
            {
              option_value: "SEG",
              option_display: "ਕੂੜਾ ਇਕੱਠਾ ਕੀਤਾ ਜਾਂਦਾ ਹੈ ਅਤੇ ਸ਼੍ਰੇਣੀ ਅਨੁਸਾਰ ਵੱਖਰੇ ਤੌਰ 'ਤੇ ਲੋਡ ਕੀਤਾ ਜਾਂਦਾ ਹੈ (ਵੱਖ ਕੀਤਾ ਜਾਂਦਾ ਹੈ)"
            },
            {
              option_value: "MIX_LOAD",
              option_display: "ਕੂੜਾ ਵੱਖਰੇ ਤੌਰ 'ਤੇ ਇਕੱਠਾ ਕੀਤਾ ਜਾਂਦਾ ਹੈ ਪਰ ਲੋਡਿੰਗ ਦੌਰਾਨ ਮਿਲਾਇਆ ਜਾਂਦਾ ਹੈ"
            },
            {
              option_value: "MIX",
              option_display: "ਕੂੜਾ ਇਕੱਠਾ ਕੀਤਾ ਜਾਂਦਾ ਹੈ ਅਤੇ ਮਿਸ਼ਰਤ ਰੂਪ ਵਿੱਚ ਲੋਡ ਕੀਤਾ ਜਾਂਦਾ ਹੈ"
            }
          ]
        },
        te: {
          questionDisplay: "చెత్త/ వ్యర్థాలను సేకరించే వ్యక్తి, చెత్త/ వ్యర్థాలను కేటగిరీల వారీగా వేరు చేసి వెహికిల్ లోకి లోడ్ చేస్తారా, లేక సేకరించే/ లోడ్ చేసే సమయంలో వాటిని కలిపేస్తారా?",
         optionValues: [
            {
              option_value: "SEG",
              option_display: "చెత్తను వేర్వేరు కేటగిరీలుగా సేకరించి, వాహనంలో కూడా వేరు వేరుగా లోడ్ చేస్తారు"
            },
            {
              option_value: "MIX_LOAD",
              option_display: "చెత్త/ వ్యర్థాలను వేర్వేరుగా సేకరిస్తారు, కానీ లోడ్ చేసే సమయంలో కలిపేస్తారు"
            },
            {
              option_value: "MIX",
              option_display: "చెత్త/ వ్యర్థాలను సేకరించే సమయంలోనే కలిపి సేకరించి, వెహికిల్ లో కూడా కలిపి లోడ్ చేస్తారు"
            }
          ]
        },
       as: {
          questionDisplay: "আৱৰ্জনা সংগ্ৰাহকজনে পৃথক পদ্ধতিত (শ্ৰেণী অনুসৰি) বাহনখনত আৱৰ্জনা সংগ্ৰহ আৰু লোড কৰে নেকি, বা সংগ্ৰহ/লোডিংৰ সময়ত ইয়াক মিহলি কৰা হয় নেকি?",
         optionValues: [
            {
              option_value: "SEG",
              option_display: "আৱৰ্জনাবোৰ শ্ৰেণী অনুসৰি পৃথকভাৱে সংগ্ৰহ আৰু লোড কৰা হয় (পৃথকীকৃত)"
            },
            {
              option_value: "MIX_LOAD",
              option_display: "আৱৰ্জনা পৃথকভাৱে সংগ্ৰহ কৰা হয় কিন্তু লোডিংৰ সময়ত মিহলি কৰা হয়"
            },
            {
              option_value: "MIX",
              option_display: "আৱৰ্জনা সংগ্ৰহ কৰা হয় আৰু মিশ্ৰিত ৰূপত লোড কৰা হয়"
            }
          ]
        },
        or: {
          questionDisplay: "ଅଳିଆ ସଂଗ୍ରହକାରୀ କ’ଣ ପୃଥକ ଭାବରେ (ବର୍ଗ ଅନୁସାରେ) ଅଳିଆ ସଂଗ୍ରହ କରି ଗାଡିରେ ଲୋଡ୍ କରନ୍ତି, ନା ସଂଗ୍ରହ/ଲୋଡିଂ ସମୟରେ ଏହାକୁ ମିଶାଇ ଦିଅନ୍ତି?",
         optionValues: [
            {
              option_value: "SEG",
              option_display: "ବର୍ଗ ଅନୁସାରେ ଅଳିଆ ସଂଗ୍ରହ ଏବଂ ଲୋଡ୍ କରାଯାଏ (ପୃଥକ ଭାବରେ)"
            },
            {
              option_value: "MIX_LOAD",
              option_display: "ଅଳିଆ ପୃଥକ ଭାବରେ ସଂଗ୍ରହ କରାଯାଏ କିନ୍ତୁ ଲୋଡିଂ ସମୟରେ ମିଶ୍ରିତ ହୁଏ"
            },
            {
              option_value: "MIX",
              option_display: "ଅଳିଆ ମିଶ୍ରିତ ରୂପରେ ସଂଗ୍ରହ ଏବଂ ଲୋଡ୍ କରାଯାଏ।"
            }
          ]
        },
       mr: {
          questionDisplay: "कचरा गोळा करणारे कर्मचारी कचरा गोळा करताना आणि गाडीत भरताना तो वेगवेगळ्या गटानुसार भरतात की गोळा करताना/भरताना मिक्स करतात?",
         optionValues: [
            {
              option_value: "SEG",
              option_display: "कचरा गटानुसार वेगळा करून गोळा केला आणि भरला जातो"
            },
            {
              option_value: "MIX_LOAD",
              option_display: "कचरा वेगवेगळा गोळा केला जातो परंतु भरताना मिक्स करतात"
            },
            {
              option_value: "MIX",
              option_display: "कचरा मिक्स करून गोळा केला आणि भरला जातो"
            }
          ]
        },
      ka: {
          questionDisplay: "ಕಸ ಸಂಗ್ರಾಹಕ ಕಸದ ವಾಹನದಲ್ಲಿ ವರ್ಗವೈವಿಧ್ಯತೆಯನ್ನು (ವಿಭಾಗ ಪ್ರಕಾರ) ಉಳಿಸಿಕೊಂಡು ಸಂಗ್ರಹಿಸುತ್ತಾರಾ, ಅಥವಾ ಮಿಶ್ರಿತವಾಗಿ ಸಂಗ್ರಹಿಸಲಾಗುತ್ತದೆಯೆ?",
         optionValues: [
            {
              option_value: "SEG",
              option_display: "ಕಸವನ್ನು ಪ್ರತ್ಯೇಕವಾಗಿ ವರ್ಗ ಪ್ರಕಾರ ಸಂಗ್ರಹಿಸಿ ವಾಹನದಲ್ಲಿ ಲೋಡ್ ಮಾಡಲಾಗುತ್ತದೆ"
            },
            {
              option_value: "MIX_LOAD",
              option_display: "ಕಸ ಪ್ರತ್ಯೇಕವಾಗಿ ಸಂಗ್ರಹಿಸಲಾಗುತ್ತದೆ ಆದರೆ ಲೋಡ್ ಸಮಯದಲ್ಲಿ ಮಿಶ್ರಿತ ಮಾಡಲಾಗುತ್ತದೆ"
            },
            {
              option_value: "MIX",
              option_display: "ಕಸ ಮಿಶ್ರಿತವಾಗಿ ಸಂಗ್ರಹಿಸಲಾಗುತ್ತದೆ ಮತ್ತು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತದೆ"
            }
          ]
        },
       bn: {
          questionDisplay: "আবর্জনা সংগ্রহকারী কি আবর্জনা সংগ্রহ ও গাড়িতে তোলার সময় তা আলাদা (শ্রেণি অনুযায়ী) করেন, নাকি সংগ্রহ বা তোলার সময় তা মিশিয়ে ফেলা হয়?",
         optionValues: [
            {
              option_value: "SEG",
              option_display: "আবর্জনা সংগ্রহ করা হয় এবং শ্রেনী অনুযায়ী আলাদাভাবে লোড করা হয় (আলাদা করা হয়)"
            },
            {
              option_value: "MIX_LOAD",
              option_display: "আবর্জনা আলাদাভাবে সংগ্রহ করা হয় কিন্তু লোড করার সময় মিশিয়ে ফেলা হয়"
            },
            {
              option_value: "MIX",
              option_display: "আবর্জনা মিশিয়ে সংগ্রহ করা হয় এবং লোড করা হয়"
            }
          ]
        },
       ta: {
          questionDisplay: "குப்பை சேகரிப்பவர் குப்பைகளைத் தனித்தனியாகப் (வகை வாரியாக) பிரித்துச் சேகரித்து வாகனத்தில் ஏற்றுகிறாரா அல்லது சேகரிக்கும்பபோதோ/ஏற்றும்பபோதோ அவை ஒன்றாக கலக்கப்படுகின்றனவா?",
         optionValues: [
            {
              option_value: "SEG",
              option_display: "கழிவுகள் வகை வாரியாக பிரிக்கப்பட்டு மேலும் தனித்தனியாக சேகரிக்கப்பட்டு ஏற்றப்படுகின்றன."
            },
            {
              option_value: "MIX_LOAD",
              option_display: "கழிவுகள் தனித்தனியாகச் சேகரிக்கப்படுகின்றன ஆனால் ஏற்றும் போது ஒன்றாக கலக்கப்படுகின்றன"
            },
            {
              option_value: "MIX",
              option_display: "கழிவுகள் கலந்த நிலையிலேயே சேகரிக்கப்பட்டு ஏற்றப்படுகின்றன."
            }
          ]
        },
        ur: {
          questionDisplay: "کیا کچرا جمع کرنے والا عملہ کچرے کو الگ الگ (اقسام کے مطابق) گاڑی میں ڈالتا ہے یا جمع کرنے/لوڈ کرنے کے دوران اسے ملا دیا جاتا ہے؟",
         optionValues: [
            {
              option_value: "SEG",
              option_display: "کچرا اقسام کے مطابق الگ الگ جمع کیا جاتا ہے اور اسی طرح لوڈ کیا جاتا ہے"
            },
            {
              option_value: "MIX_LOAD",
              option_display: "کچرا الگ الگ جمع کیا جاتا ہے لیکن لوڈ کرتے وقت ملا دیا جاتا ہے"
            },
            {
              option_value: "MIX",
              option_display: "کچرا ملا جلا حالت میں جمع کیا جاتا ہے اور اسی طرح لوڈ کیا جاتا ہے"
            }
          ]
        },
        gu: {
          questionDisplay: "શું કચરો એકત્રિત કરનાર કચરો અલગ અલગ રીતે (કેટેગરી દ્વારા) એકત્રિત કરે છે અને વાહનમાં લોડ કરે છે, અથવા એકત્રિત કરતી વખતે/લોડિંગ દરમિયાન તેને મિક્સ કરવામાં આવે છે?",
         optionValues: [
            {
              option_value: "SEG",
              option_display: "કચરો કેટેગરી દ્વારા અલગથી એકત્રિત અને લોડ કરવામાં આવે છે (અલગ કરીને)"
            },
            {
              option_value: "MIX_LOAD",
              option_display: "કચરો અલગથી એકત્રિત કરવામાં આવે છે પણ લોડિંગ દરમિયાન મિક્સ કરવામાં આવે છે"
            },
            {
              option_value: "MIX",
              option_display: "કચરો એકત્રિત કરવામાં આવે છે અને મિક્સ કરીને લોડ કરવામાં આવે છે"
            }
          ]
        },
        ml: {
          questionDisplay: "മാലിന്യ ശേഖരണം നടത്തുന്നയാൾ വാഹനത്തിൽ മാലിന്യം ശേഖരിച്ച് കയറ്റുന്നത് (വിഭാഗം അനുസരിച്ച്) ആണോ, അതോ ശേഖരണ/ലോഡിംഗ് സമയത്ത് അത് മിക്സ് ചെയ്യാറുണ്ടോ ?",
         optionValues: [
            {
              option_value: "SEG",
              option_display: "വിഭാഗം അനുസരിച്ച് മാലിന്യങ്ങൾ പ്രത്യേകം ശേഖരിച്ച് ലോഡ് ചെയ്യുന്നു (വേർതിരിച്ചിരിക്കുന്നു)"
            },
            {
              option_value: "MIX_LOAD",
              option_display: "മാലിന്യങ്ങൾ പ്രത്യേകം ശേഖരിക്കുന്നു, പക്ഷേ ലോഡിംഗ് സമയത്ത് മിക്സ് ചെയ്യുന്നു"
            },
            {
              option_value: "MIX",
              option_display: "മാലിന്യങ്ങൾ ശേഖരിച്ച് മിശ്രിത രൂപത്തിലാണ് ലോഡ് ചെയ്യുന്നത്."
            }
          ]
        }
      }
    },
    {
      questionDisplay: "Does daily sweeping take place in your area?",
      optionType: "Single choice",
     optionValues: [
        {
          option_value: "Y",
          option_display: "Yes"
        },
        {
          option_value: "N",
          option_display: "No"
        }
      ],
      questionCode: "FQ4",
      questionId: 4,
      questionDisplayOrder: 4,
      languages: {
        hi: {
          questionDisplay: "क्या आपके इलाके में रोज़ाना झाड़ू लगाई जाती है?",
         optionValues: [
            {
              option_value: "Y",
              option_display: "हाँ"
            },
            {
              option_value: "N",
              option_display: "नहीं"
            }
          ]
        },
         pa: {
          questionDisplay: "ਕੀ ਤੁਹਾਡੇ ਇਲਾਕੇ ਵਿੱਚ ਰੋਜ਼ਾਨਾ ਸਫ਼ਾਈ ਕੀਤੀ ਜਾਂਦੀ ਹੈ?",
         optionValues: [
            {
              option_value: "Y",
              option_display: "ਹਾਂ"
            },
            {
              option_value: "N",
              option_display: "ਨਹੀਂ"
            }
          ]
        },
        te: {
          questionDisplay: "మీ ప్రాంతంలో ప్రతిరోజూ స్వీపింగ్/ శుభ్రపరిచే కార్యక్రమం జరుగుతుందా?",
         optionValues: [
            {
              option_value: "Y",
              option_display: "అవును"
            },
            {
              option_value: "N",
              option_display: "లేదు"
            }
          ]
        },
       as: {
          questionDisplay: "আপোনাৰ অঞ্চলটোত দৈনিক পৰিস্কাৰ কৰা হয় নেকি?",
         optionValues: [
            {
              option_value: "Y",
              option_display: "হয়"
            },
            {
              option_value: "N",
              option_display: "নহয়"
            }
          ]
        },
        or: {
          questionDisplay: "ଆପଣଙ୍କ ଅଞ୍ଚଳରେ ପ୍ରତିଦିନ ଝାଡ଼ୁ କରାଯାଏ କି?",
         optionValues: [
            {
              option_value: "Y",
              option_display: "ହଁ"
            },
            {
              option_value: "N",
              option_display: "ନା"
            }
          ]
        },
       mr: {
          questionDisplay: "तुमच्या परिसरात दररोज झाडलोट केले जाते का?",
         optionValues: [
            {
              option_value: "Y",
              option_display: "होय"
            },
            {
              option_value: "N",
              option_display: "नाही"
            }
          ]
        },
      ka: {
          questionDisplay: "ನಿಮ್ಮ ಪ್ರದೇಶದಲ್ಲಿ ದಿನನಿತ್ಯ ಸ್ವೀಪಿಂಗ್ ನಡೆಯುತ್ತದೆಯೆ?",
         optionValues: [
            {
              option_value: "Y",
              option_display: "ಹೌದು"
            },
            {
              option_value: "N",
              option_display: "ಇಲ್ಲ"
            }
          ]
        },
       bn: {
          questionDisplay: "আপনাদের এলাকায় কি প্রতিদিন ঝাড়ু দেওয়া হয়?",
         optionValues: [
            {
              option_value: "Y",
              option_display: "হ্যাঁ"
            },
            {
              option_value: "N",
              option_display: "না"
            }
          ]
        },
       ta: {
          questionDisplay: "உங்கள் பகுதியில் தினமும் சுத்தம் செய்யும் பணி நடைபெறுகிறதா?",
         optionValues: [
            {
              option_value: "Y",
              option_display: "ஆம்"
            },
            {
              option_value: "N",
              option_display: "இல்லை"
            }
          ]
        },
        ur: {
          questionDisplay: "کیا آپ کے علاقے میں روزانہ صفائی (جھاڑو) کی جاتی ہے؟",
         optionValues: [
            {
              option_value: "Y",
              option_display: "جی ہاں"
            },
            {
              option_value: "N",
              option_display: "نہیں"
            }
          ]
        },
        gu: {
          questionDisplay: "શું તમારા વિસ્તારમાં દરરોજ સફાઈ કરવામાં આવે છે?",
         optionValues: [
            {
              option_value: "Y",
              option_display: "હા"
            },
            {
              option_value: "N",
              option_display: "ના"
            }
          ]
        },
        ml: {
          questionDisplay: "നിങ്ങളുടെ പ്രദേശത്ത് ദിവസേന തൂപ്പുപണി നടക്കാറുണ്ടോ?",
         optionValues: [
            {
              option_value: "Y",
              option_display: "അതെ"
            },
            {
              option_value: "N",
              option_display: "ഇല്ല"
            }
          ]
        }
      }
    },
    {
      questionDisplay: "How would you rate the cleanliness of your residential area in terms of visible cleanliness?",
      optionType: "Single choice",
     optionValues: [
        {
          option_value: "VP",
          option_display: "Very Poor"
        },
        {
          option_value: "P",
          option_display: "Poor"
        },
        {
          option_value: "AVG",
          option_display: "Average"
        },
        {
          option_value: "G",
          option_display: "Good"
        },
        {
          option_value: "EX",
          option_display: "Excellent"
        }
      ],
      questionCode: "FQ5",
      questionId: 5,
      questionDisplayOrder: 5,
      languages: {
        hi: {
          questionDisplay: "आप अपने इलाके की साफ़-सफ़ाई को साफ़-सफ़ाई के मामले में कैसे रेट करेंगे?",
         optionValues: [
            {
              option_value: "VP",
              option_display: "बहुत खराब"
            },
            {
              option_value: "P",
              option_display: "खराब"
            },
            {
              option_value: "AVG",
              option_display: "औसत"
            },
            {
              option_value: "G",
              option_display: "अच्छा"
            },
            {
              option_value: "EX",
              option_display: "सर्वोत्‍तम"
            }
          ]
        },
         pa: {
          questionDisplay: "ਤੁਸੀਂ ਆਪਣੇ ਰਿਹਾਇਸ਼ੀ ਇਲਾਕੇ ਦੀ ਸਾਫ਼-ਸਫ਼ਾਈ ਨੂੰ ਦਿਖਾਈ ਦੇਣ ਵਾਲੀ ਸਫ਼ਾਈ ਦੇ ਮਾਮਲੇ ਵਿੱਚ ਕਿਵੇਂ ਦਰਜਾ ਦਿਓਗੇ?",
         optionValues: [
            {
              option_value: "VP",
              option_display: "ਬਹੁਤ ਮਾੜਾ"
            },
            {
              option_value: "P",
              option_display: "ਮਾੜਾ"
            },
            {
              option_value: "AVG",
              option_display: "ਔਸਤ"
            },
            {
              option_value: "G",
              option_display: "ਚੰਗਾ"
            },
            {
              option_value: "EX",
              option_display: "ਸ਼ਾਨਦਾਰ"
            }
          ]
        },
        te: {
          questionDisplay: "కంటికి కనిపించే శుభ్రత పరంగా మీరు నివాసముండే ప్రాంతం యొక్క పరిశుభ్రతకు మీరు ఏ రేటింగ్ ఇస్తారు?",
         optionValues: [
            {
              option_value: "VP",
              option_display: "ఏమీ బాగాలేదు"
            },
            {
              option_value: "P",
              option_display: "బాగాలేదు"
            },
            {
              option_value: "AVG",
              option_display: "పరవాలేదు"
            },
            {
              option_value: "G",
              option_display: "బాగుంది"
            },
            {
              option_value: "EX",
              option_display: "అధ్బుతంగా ఉంది"
            }
          ]
        },
       as: {
          questionDisplay: "দৃশ্যমান পৰিষ্কাৰ-পৰিচ্ছন্নতাৰ ক্ষেত্ৰত আপুনি আপোনাৰ আৱাসিক অঞ্চলৰ পৰিষ্কাৰ-পৰিচ্ছন্নতাক কেনেদৰে মূল্যায়ন কৰিব?",
         optionValues: [
            {
              option_value: "VP",
              option_display: "খুবেই বেয়া"
            },
            {
              option_value: "P",
              option_display: "বেয়া"
            },
            {
              option_value: "AVG",
              option_display: "যথোচিত"
            },
            {
              option_value: "G",
              option_display: "ভাল"
            },
            {
              option_value: "EX",
              option_display: "উৎকৃষ্ট"
            }
          ]
        },
        or: {
          questionDisplay: "ଦୃଶ୍ୟମାନ ପରିଷ୍କାର ପରିଚ୍ଛନ୍ନତା ଦୃଷ୍ଟିରୁ ଆପଣ ଆପଣଙ୍କ ଆବାସିକ ଅଞ୍ଚଳର ପରିଷ୍କାର ପରିଚ୍ଛନ୍ନତାକୁ କିପରି ମୂଲ୍ୟାଙ୍କନ କରିବେ?",
         optionValues: [
            {
              option_value: "VP",
              option_display: "ବହୁତ ଖରାପ"
            },
            {
              option_value: "P",
              option_display: "ଖରାପ "
            },
            {
              option_value: "AVG",
              option_display: "ହାରାହାରି"
            },
            {
              option_value: "G",
              option_display: "ଭଲ"
            },
            {
              option_value: "EX",
              option_display: "ଉତ୍କୃଷ୍ଟ"
            }
          ]
        },
       mr: {
          questionDisplay: "स्पष्ट दिसून येणाऱ्या स्वच्छतेच्या संदर्भात तुम्ही तुमच्या निवासी भागातील स्वच्छतेला किती रेटिंग द्याल?",
         optionValues: [
            {
              option_value: "VP",
              option_display: "खूप खराब"
            },
            {
              option_value: "P",
              option_display: "खराब"
            },
            {
              option_value: "AVG",
              option_display: "साधारण"
            },
            {
              option_value: "G",
              option_display: "चांगले"
            },
            {
              option_value: "EX",
              option_display: "उत्कृष्ट"
            }
          ]
        },
      ka: {
          questionDisplay: "ದೃಶ್ಯ ಸ್ವಚ್ಚತೆ ಕುರಿತು ನಿಮ್ಮ ನಿವಾಸ ಪ್ರದೇಶವನ್ನು ನೀವು ಹೇಗೆ ಅಂಕಿತಮಾಡುತ್ತೀರಿ?",
         optionValues: [
            {
              option_value: "VP",
              option_display: "ಬಹಳ ಕೆಟ್ಟದು"
            },
            {
              option_value: "P",
              option_display: "ಕೆಟ್ಟದು"
            },
            {
              option_value: "AVG",
              option_display: "ಸರಾಸರಿ"
            },
            {
              option_value: "G",
              option_display: "ಉತ್ತಮ"
            },
            {
              option_value: "EX",
              option_display: "ಅತ್ಯುತ್ತಮ"
            }
          ]
        },
       bn: {
          questionDisplay: "চোখে পড়ার মতো পরিচ্ছন্নতার বিচারে, আপনি আপনার বাড়ির এলাকার পরিচ্ছন্নতাকে কীভাবে মূল্যায়ন করবেন?",
         optionValues: [
            {
              option_value: "VP",
              option_display: "খুব খারাপ"
            },
            {
              option_value: "P",
              option_display: "খারাপ"
            },
            {
              option_value: "AVG",
              option_display: "গড়পরতা"
            },
            {
              option_value: "G",
              option_display: "ভাল"
            },
            {
              option_value: "EX",
              option_display: "দারুন"
            }
          ]
        },
       ta: {
          questionDisplay: "கண்ணுக்கு தெரியும் தூய்மையின் படி, உங்கள் குடியிருப்பு பகுதியின் சுத்தத்தை நீங்கள் எவ்வாறு மதிப்பிடுவீர்கள்?",
         optionValues: [
            {
              option_value: "VP",
              option_display: "மிகவும் மோசம்"
            },
            {
              option_value: "P",
              option_display: "மோசம்"
            },
            {
              option_value: "AVG",
              option_display: "சராசரியானது"
            },
            {
              option_value: "G",
              option_display: "நன்று"
            },
            {
              option_value: "EX",
              option_display: "மிகச்சிறந்தது"
            }
          ]
        },
        ur: {
          questionDisplay: "آپ اپنے رہائشی علاقے کی صفائی کو ظاہری صفائی کے لحاظ سے کیسے درجہ دیں گے؟",
         optionValues: [
            {
              option_value: "VP",
              option_display: "بہت خراب"
            },
            {
              option_value: "P",
              option_display: "خراب"
            },
            {
              option_value: "AVG",
              option_display: "اوسط"
            },
            {
              option_value: "G",
              option_display: "اچھا"
            },
            {
              option_value: "EX",
              option_display: "بہترین"
            }
          ]
        },
        gu: {
          questionDisplay: "દેખાતી સ્વચ્છતાના સંદર્ભમાં તમે તમારા રહેણાંક વિસ્તારની સ્વચ્છતાને કેવી રીતે રેટ કરશો?",
         optionValues: [
            {
              option_value: "VP",
              option_display: "ખૂબજ ખરાબ"
            },
            {
              option_value: "P",
              option_display: "ખરાબ"
            },
            {
              option_value: "AVG",
              option_display: "સરેરાશ"
            },
            {
              option_value: "G",
              option_display: "સારી"
            },
            {
              option_value: "EX",
              option_display: "ઉત્તમ"
            }
          ]
        },
        ml: {
          questionDisplay: "ദൃശ്യമായ ശുചിത്വത്തിന്റെ അടിസ്ഥാനത്തിൽ നിങ്ങളുടെ താമസ പ്രദേശത്തിന്റെ ശുചിത്വത്തെ നിങ്ങൾ എങ്ങനെ വിലയിരുത്തുന്നു?",
         optionValues: [
            {
              option_value: "VP",
              option_display: "വളരെ മോശം"
            },
            {
              option_value: "P",
              option_display: "മോശം"
            },
            {
              option_value: "AVG",
              option_display: "ശരാശരി"
            },
            {
              option_value: "G",
              option_display: "നല്ലത്"
            },
            {
              option_value: "EX",
              option_display: "മികച്ചത്"
            }
          ]
        }
      }
    },
    {
      questionDisplay: "How often do you see unattended garbage dumps or garbage piles near your area?",
      optionType: "Single choice",
     optionValues: [
        {
          option_value: "N",
          option_display: "Never"
        },
        {
          option_value: "R",
          option_display: "Rarely"
        },
        {
          option_value: "S",
          option_display: "Sometimes"
        },
        {
          option_value: "O",
          option_display: "Often"
        },
        {
          option_value: "VO",
          option_display: "Very Often"
        }
      ],
      questionCode: "FQ6",
      questionId: 6,
      questionDisplayOrder: 6,
      languages: {
        hi: {
          questionDisplay: "आप अपने इलाके के आस-पास कितनी बार लावारिस कूड़े के ढेर या कचरे के ढेर देखते हैं?",
         optionValues: [
            {
              option_value: "N",
              option_display: "कभी नहीं"
            },
            {
              option_value: "R",
              option_display: "कभी-कभार"
            },
            {
              option_value: "S",
              option_display: "कभी-कभी"
            },
            {
              option_value: "O",
              option_display: "अक्सर"
            },
            {
              option_value: "VO",
              option_display: "बहुत बार"
            }
          ]
        },
         pa: {
          questionDisplay: "ਤੁਸੀਂ ਆਪਣੇ ਇਲਾਕੇ ਦੇ ਨੇੜੇ ਕਿੰਨੀ ਵਾਰ ਅਣਗੌਲਿਆ ਕੂੜਾ ਡੰਪ ਜਾਂ ਕੂੜੇ ਦੇ ਢੇਰ ਦੇਖਦੇ ਹੋ?",
         optionValues: [
            {
              option_value: "N",
              option_display: "ਕਦੇ ਨਹੀਂ"
            },
            {
              option_value: "R",
              option_display: "ਕਦੇ"
            },
            {
              option_value: "S",
              option_display: "ਕਦੇ - ਕਦੇ"
            },
            {
              option_value: "O",
              option_display: "ਅਕਸਰ"
            },
            {
              option_value: "VO",
              option_display: "ਬਹੁਤ ਵਾਰ"
            }
          ]
        },
        te: {
          questionDisplay: "మీ ప్రాంతానికి దగ్గరలో పట్టించుకోకుండా/ ఎవరూ చూసుకోని చెత్త కుప్పలు లేదా చెత్త పేరుకుపోయిన ప్రదేశాలు ఎంత తరచుగా కనిపిస్తాయి?",
         optionValues: [
            {
              option_value: "N",
              option_display: "ఎప్పుడూ లేదు"
            },
            {
              option_value: "R",
              option_display: "అరుదుగా"
            },
            {
              option_value: "S",
              option_display: "కొన్నిసార్లు"
            },
            {
              option_value: "O",
              option_display: "తరచుగా"
            },
            {
              option_value: "VO",
              option_display: "చాలా తరచుగా"
            }
          ]
        },
       as: {
          questionDisplay: "আপোনাৰ অঞ্চলৰ ওচৰত আপুনি কিমান বাৰ অব্যৱস্থিত আৱৰ্জনা ডাম্প বা আৱৰ্জনাৰ স্তূপ দেখা পায়?",
         optionValues: [
            {
              option_value: "N",
              option_display: "কেতিয়াও নহয়"
            },
            {
              option_value: "R",
              option_display: "কাচিৎহে"
            },
            {
              option_value: "S",
              option_display: "কেতিয়াবা"
            },
            {
              option_value: "O",
              option_display: "সঘনাই"
            },
            {
              option_value: "VO",
              option_display: "খুবেই সঘনাই"
            }
          ]
        },
        or: {
          questionDisplay: "ଆପଣଙ୍କ ଅଞ୍ଚଳ ନିକଟରେ ଆପଣ କେତେଥର ଅଣଦେଖା ହୋଇଥିବା ଅଳିଆ ଗଦା କିମ୍ବା ଅଳିଆ ଗଦା ଦେଖନ୍ତି?",
         optionValues: [
            {
              option_value: "N",
              option_display: "କେବେବି ନୁହେଁ"
            },
            {
              option_value: "R",
              option_display: "କ୍ୱଚିତ୍"
            },
            {
              option_value: "S",
              option_display: "ବେଳେବେଳେ"
            },
            {
              option_value: "O",
              option_display: "ପ୍ରାୟତଃ"
            },
            {
              option_value: "VO",
              option_display: "ବହୁତ ସମୟରେ"
            }
          ]
        },
       mr: {
          questionDisplay: "तुम्हाला किती वेळा तुमच्या परिसराजवळ दुर्लक्षित कचऱ्याचा ढिगारा किंवा कचऱ्याचा ढीग दिसतो?",
         optionValues: [
            {
              option_value: "N",
              option_display: "कधीच नाही"
            },
            {
              option_value: "R",
              option_display: "क्वचितच"
            },
            {
              option_value: "S",
              option_display: "कधीकधी"
            },
            {
              option_value: "O",
              option_display: "बऱ्याचदा"
            },
            {
              option_value: "VO",
              option_display: "खुप वेळा"
            }
          ]
        },
      ka: {
          questionDisplay: "ನಿಮ್ಮ ಪ್ರದೇಶದ ಹತ್ತಿರ ನಿರೀಕ್ಷೆ ಮಾಡದ ಕಸದ ಗುಡ್ಡಗಳು ಅಥವಾ ಕಸದ ಬೋಡಿಗಳನ್ನು ನೀವು ಎಷ್ಟು ಬಾರಿ ನೋಡುತ್ತೀರಿ?",
         optionValues: [
            {
              option_value: "N",
              option_display: "ಎಂದಿಗೂ ಇಲ್ಲ"
            },
            {
              option_value: "R",
              option_display: "ಬಹಳ ವಿರಳವಾಗಿ"
            },
            {
              option_value: "S",
              option_display: "ಕೆಲವೊಮ್ಮೆ"
            },
            {
              option_value: "O",
              option_display: "ಪ್ರಾಯೋಗಿಕವಾಗಿ"
            },
            {
              option_value: "VO",
              option_display: "ಬಹಳ ಸಮಯದಲ್ಲಿ"
            }
          ]
        },
       bn: {
          questionDisplay: "আপনি কত ঘন ঘন আপনার এলাকায় আবর্জনা জমা করে/ ফেলে রাখতে দেখেন?",
         optionValues: [
            {
              option_value: "N",
              option_display: "কখনোই নয়"
            },
            {
              option_value: "R",
              option_display: "খুব কম"
            },
            {
              option_value: "S",
              option_display: "মাঝে-মধ্যে"
            },
            {
              option_value: "O",
              option_display: "প্রায়"
            },
            {
              option_value: "VO",
              option_display: "খুব ঘন ঘন"
            }
          ]
        },
       ta: {
          questionDisplay: "உங்கள் பகுதிக்கு அருகில் கவனிக்கப்படாத குப்பை மேடுகளையோ அல்லது குப்பைக் குவியல்களையோ நீங்கள் எந்தளவு அடிக்கடி காண்கிறீர்கள்?",
         optionValues: [
            {
              option_value: "N",
              option_display: "ஒருபோதுமில்லை"
            },
            {
              option_value: "R",
              option_display: "அரிதாக"
            },
            {
              option_value: "S",
              option_display: "சில சமயங்களில்"
            },
            {
              option_value: "O",
              option_display: "அடிக்கடி"
            },
            {
              option_value: "VO",
              option_display: "மிகவும் அடிக்கடி"
            }
          ]
        },
        ur: {
          questionDisplay: "آپ اپنے علاقے کے قریب بغیر دیکھ بھال کے کچرے کے ڈھیر کتنی بار دیکھتے ہیں؟",
         optionValues: [
            {
              option_value: "N",
              option_display: "کبھی نہیں"
            },
            {
              option_value: "R",
              option_display: "شاذ و نادر ہی"
            },
            {
              option_value: "S",
              option_display: "کبھی کبھار"
            },
            {
              option_value: "O",
              option_display: "اکثر"
            },
            {
              option_value: "VO",
              option_display: "بہت زیادہ اکثر"
            }
          ]
        },
        gu: {
          questionDisplay: "તમારા વિસ્તારની નજીક તમે કેટલી વાર કચરાના ઢગલા કે કચરાને ડમ્પ કરેલા જુઓ છો?",
         optionValues: [
            {
              option_value: "N",
              option_display: "ક્યારેય નહી"
            },
            {
              option_value: "R",
              option_display: "ભાગ્યેજ"
            },
            {
              option_value: "S",
              option_display: "કેટલીકવાર"
            },
            {
              option_value: "O",
              option_display: "ઘણીવાર"
            },
            {
              option_value: "VO",
              option_display: "ખૂબજ વારંવાર"
            }
          ]
        },
        ml: {
          questionDisplay: "നിങ്ങളുടെ പ്രദേശത്തിന് സമീപം ശ്രദ്ധിക്കപ്പെടാത്ത മാലിന്യക്കൂമ്പാരങ്ങളോ മാലിന്യക്കൂനകളോ  നിങ്ങൾ എത്രഇടവിട്ട്  കാണാറുണ്ട്?",
         optionValues: [
            {
              option_value: "N",
              option_display: "ഒരിക്കലും"
            },
            {
              option_value: "R",
              option_display: "അപൂർവ്വമായി"
            },
            {
              option_value: "S",
              option_display: "ചിലപ്പോൾ"
            },
            {
              option_value: "O",
              option_display: "പലപ്പോഴും"
            },
            {
              option_value: "VO",
              option_display: "വളരെ പലപ്പോഴും"
            }
          ]
        }
      }
    },
    {
      questionDisplay: "How effective do you think the local authorities are in maintaining cleanliness in public spaces like markets, bazaars, parks, gardens or other areas?",
      optionType: "Single choice",
     optionValues: [
        {
          option_value: "VI",
          option_display: "Very Ineffective"
        },
        {
          option_value: "I",
          option_display: "Ineffective"
        },
        {
          option_value: "N",
          option_display: "Neutral"
        },
        {
          option_value: "E",
          option_display: "Effective"
        },
        {
          option_value: "VE",
          option_display: "Very Effective"
        }
      ],
      questionCode: "FQ7",
      questionId: 7,
      questionDisplayOrder: 7,
      languages: {
        hi: {
          questionDisplay: "आपके अनुसार स्थानीय प्रशासन मार्केट, बाज़ार, पार्क, गार्डन या दूसरी जगहों जैसी सार्वजनिक जगहों पर साफ़-सफ़ाई बनाए रखने में कितनी असरदार हैं?",
         optionValues: [
            {
              option_value: "VI",
              option_display: " बहुत अप्रभावी"
            },
            {
              option_value: "I",
              option_display: "अप्रभावी"
            },
            {
              option_value: "N",
              option_display: "तटस्थ"
            },
            {
              option_value: "E",
              option_display: "प्रभावी"
            },
            {
              option_value: "VE",
              option_display: "बहुत प्रभावी"
            }
          ]
        },
         pa: {
          questionDisplay: "ਤੁਹਾਨੂੰ ਕੀ ਲੱਗਦਾ ਹੈ ਕਿ ਸਥਾਨਕ ਅਧਿਕਾਰੀ ਬਾਜ਼ਾਰਾਂ, ਬਾਜ਼ਾਰਾਂ, ਪਾਰਕਾਂ, ਬਗੀਚਿਆਂ ਜਾਂ ਹੋਰ ਖੇਤਰਾਂ ਵਰਗੀਆਂ ਜਨਤਕ ਥਾਵਾਂ 'ਤੇ ਸਫਾਈ ਬਣਾਈ ਰੱਖਣ ਵਿੱਚ ਕਿੰਨੇ ਪ੍ਰਭਾਵਸ਼ਾਲੀ ਹਨ?",
         optionValues: [
            {
              option_value: "VI",
              option_display: "ਬਹੁਤ ਬੇਅਸਰ"
            },
            {
              option_value: "I",
              option_display: "ਬੇਅਸਰ"
            },
            {
              option_value: "N",
              option_display: "ਨਿਰਪੱਖ"
            },
            {
              option_value: "E",
              option_display: "ਪ੍ਰਭਾਵਸ਼ਾਲੀ"
            },
            {
              option_value: "VE",
              option_display: "ਬਹੁਤ ਪ੍ਰਭਾਵਸ਼ਾਲੀ"
            }
          ]
        },
        te: {
          questionDisplay: "మార్కెట్స్, బజార్స్, పార్కులు, గార్డెన్స్ లేదా ఇతర ప్రాంతాల వంటి బహిరంగ పబ్లిక్ ప్రదేశాలలో పరిశుభ్రతను కాపాడుకోవడంలో స్థానిక అధికారులు ఎంత ప్రభావవంతంగా ఉన్నారని మీరు అనుకుంటున్నారు?",
         optionValues: [
            {
              option_value: "VI",
              option_display: " చాలా ప్రభావవంతంగా ఉన్నారు"
            },
            {
              option_value: "I",
              option_display: "ప్రభావవంతంగా లేరు"
            },
            {
              option_value: "N",
              option_display: "తటస్థంగా ఉన్నారు"
            },
            {
              option_value: "E",
              option_display: "ప్రభావవంతంగా ఉన్నారు"
            },
            {
              option_value: "VE",
              option_display: "చాలా ప్రభావవంతంగా ఉన్నారు"
            }
          ]
        },
       as: {
          questionDisplay: "বজাৰ, উদ্যান, বাগিচা বা অন্যান্য অঞ্চলৰ দৰে ৰাজহুৱা স্থানত পৰিষ্কাৰ-পৰিচ্ছন্নতা বজাই ৰখাত স্থানীয় কৰ্তৃপক্ষই কিমান ফলপ্ৰসূ হৈছে বুলি আপুনি ভাবে?",
         optionValues: [
            {
              option_value: "VI",
              option_display: "খুবেই অকাৰ্যকৰী"
            },
            {
              option_value: "I",
              option_display: "অকাৰ্যকৰী"
            },
            {
              option_value: "N",
              option_display: "নিৰপেক্ষ"
            },
            {
              option_value: "E",
              option_display: "কাৰ্যকৰী"
            },
            {
              option_value: "VE",
              option_display: "খুবেই কাৰ্যকৰী"
            }
          ]
        },
        or: {
          questionDisplay: "ମାର୍କେଟ, ବଜାର, ପାର୍କ, ଉଦ୍ୟାନ କିମ୍ବା ଅନ୍ୟାନ୍ୟ ଅଞ୍ଚଳ ପରି ସାର୍ବଜନୀନ(ପବ୍ଲିକ) ସ୍ଥାନଗୁଡ଼ିକରେ ସଫାସୁତୁରା ବଜାୟ ରଖିବାରେ ସ୍ଥାନୀୟ କର୍ତ୍ତୃପକ୍ଷ କେତେ ପ୍ରଭାବଶାଳୀ ବୋଲି ଆପଣ ଭାବନ୍ତି?",
         optionValues: [
            {
              option_value: "VI",
              option_display: " ଅତ୍ୟନ୍ତ ପ୍ରଭାବଶାଳୀ"
            },
            {
              option_value: "I",
              option_display: "ଅଣପ୍ରଭାବଶାଳୀ"
            },
            {
              option_value: "N",
              option_display: "ନିରପେକ୍ଷ"
            },
            {
              option_value: "E",
              option_display: "ପ୍ରଭାବଶାଳୀ"
            },
            {
              option_value: "VE",
              option_display: "ବହୁତ ପ୍ରଭାବଶାଳୀ"
            }
          ]
        },
       mr: {
          questionDisplay: "तुमच्या मते, बाजार, उद्याने, बागांसारख्या सार्वजनिक ठिकाणी किंवा इतर परिसरात स्वच्छता  राखण्यात स्थानिक प्रशासन किती प्रभावी आहे?",
         optionValues: [
            {
              option_value: "VI",
              option_display: "अजिबात प्रभावी नाही "
            },
            {
              option_value: "I",
              option_display: "प्रभावी नाही"
            },
            {
              option_value: "N",
              option_display: "तटस्थ"
            },
            {
              option_value: "E",
              option_display: "प्रभावी"
            },
            {
              option_value: "VE",
              option_display: "खुप प्रभावी"
            }
          ]
        },
      ka: {
          questionDisplay: "ಮಾರುಕಟ್ಟೆ, ಬಜಾರ್, ಉದ್ಯಾನಗಳು ಅಥವಾ ಇತರ ಸಾರ್ವಜನಿಕ ಸ್ಥಳಗಳಲ್ಲಿ ಸ್ಥಳೀಯ ಅಧಿಕಾರಿಗಳು ಸ್ವಚ್ಚತೆಯನ್ನು ಕಾಪಾಡುವಲ್ಲಿ ಎಷ್ಟು ಪರಿಣಾಮಕಾರಿಯಾಗಿದ್ದಾರೆ ಎಂದು ನೀವು ಭಾವಿಸುತ್ತೀರಿ?",
         optionValues: [
            {
              option_value: "VI",
              option_display: "ತುಂಬಾ ಅಪ್ರಭಾವಿ"
            },
            {
              option_value: "I",
              option_display: "ಅಪ್ರಭಾವಿ"
            },
            {
              option_value: "N",
              option_display: "ತಟಸ್ಥ"
            },
            {
              option_value: "E",
              option_display: "ಪರಿಣಾಮಕಾರಿ"
            },
            {
              option_value: "VE",
              option_display: "ಅತ್ಯಂತ ಪರಿಣಾಮಕಾರಿ"
            }
          ]
        },
       bn: {
          questionDisplay: "বাজার, পার্ক, বাগান অথবা অন্যান্য এলাকাগুলোর মতো জনবহুল স্থানগুলোতে পরিচ্ছন্নতা বজায় রাখার ক্ষেত্রে স্থানীয় কর্তৃপক্ষ কতটা কার্যকর বলে আপনি মনে করেন?",
         optionValues: [
            {
              option_value: "VI",
              option_display: "খুব অকার্যকর"
            },
            {
              option_value: "I",
              option_display: "অকার্যকর"
            },
            {
              option_value: "N",
              option_display: "কার্যকর ও নয় আবার অকার্যকর ও নয়"
            },
            {
              option_value: "E",
              option_display: "কার্যকর "
            },
            {
              option_value: "VE",
              option_display: "খুব কার্যকর"
            }
          ]
        },
       ta: {
          questionDisplay: "மார்கெட்கள், கடைவீதிகள், பூங்காக்கள், தோட்டங்கள் அல்லது பிற பகுதிகள் போன்ற பொது இடங்களில் தூய்மையைப் பராமரிப்பதில் உள்ளூர் அதிகாரிகள் எந்தளவு திறம்பட செயல்படுகிறார்கள் என்று நீங்கள் நினைக்கிறீர்கள்?",
         optionValues: [
            {
              option_value: "VI",
              option_display: "மிகவும் ஆற்றல்மிக்கதல்ல"
            },
            {
              option_value: "I",
              option_display: "ஆற்றல்மிக்கதல்ல"
            },
            {
              option_value: "N",
              option_display: "நடுநிலை"
            },
            {
              option_value: "E",
              option_display: "ஆற்றல்மிக்கது"
            },
            {
              option_value: "VE",
              option_display: "மிகவும் ஆற்றல்மிக்கது"
            }
          ]
        },
        ur: {
          questionDisplay: "آپ کے خیال میں مقامی حکام بازاروں، مارکیٹوں، پارکوں، باغات یا دیگر عوامی مقامات پر صفائی برقرار رکھنے میں کتنے مؤثر ہیں؟",
         optionValues: [
            {
              option_value: "VI",
              option_display: "بالکل غیر مؤثر"
            },
            {
              option_value: "I",
              option_display: "غیر مؤثر"
            },
            {
              option_value: "N",
              option_display: "غیر جانبدار"
            },
            {
              option_value: "E",
              option_display: "مؤثر"
            },
            {
              option_value: "VE",
              option_display: "بہت مؤثر"
            }
          ]
        },
        gu: {
          questionDisplay: "તમારા અભિપ્રાયમાં, માર્કેટ્સ, બજારો, પાર્ક, ગાર્ડન્સ કે અન્ય વિસ્તારો જેવા જાહેર સ્થળોએ સ્વચ્છતા જાળવવામાં સ્થાનિક અધિકારીઓ કેટલા અસરકારક છે?",
         optionValues: [
            {
              option_value: "VI",
              option_display: "ખૂબજ બિનઅસરકારક"
            },
            {
              option_value: "I",
              option_display: "બિનઅસરકારક"
            },
            {
              option_value: "N",
              option_display: "તટસ્થ"
            },
            {
              option_value: "E",
              option_display: "અસરકારક"
            },
            {
              option_value: "VE",
              option_display: "ખૂબજ અસરકારક"
            }
          ]
        },
        ml: {
          questionDisplay: "മാർക്കറ്റുകൾ, ചന്തകൾ, പാർക്കുകൾ, പൂന്തോട്ടങ്ങൾ അല്ലെങ്കിൽ മറ്റ് പ്രദേശങ്ങൾ പോലുള്ള പൊതു ഇടങ്ങളിൽ ശുചിത്വം പാലിക്കുന്നതിൽ തദ്ദേശ സ്വയംഭരണ സ്ഥാപനങ്ങൾ എത്രത്തോളം ഫലപ്രദമാണെന്ന് നിങ്ങൾ കരുതുന്നു?",
         optionValues: [
            {
              option_value: "VI",
              option_display: "വളരെ ഫലപ്രദമല്ലാത്തത്"
            },
            {
              option_value: "I",
              option_display: "ഫലപ്രദമല്ലാത്തത്"
            },
            {
              option_value: "N",
              option_display: "നിഷ്പക്ഷത"
            },
            {
              option_value: "E",
              option_display: "ഫലപ്രദം"
            },
            {
              option_value: "VE",
              option_display: "വളരെ ഫലപ്രദം"
            }
          ]
        }
      }
    },
    {
      questionDisplay: "Do you see people openly urinating or defecating in public or nearby areas?",
      optionType: "Single choice",
     optionValues: [
        {
          option_value: "NN",
          option_display: "No, never"
        },
        {
          option_value: "YR",
          option_display: "Yes, rarely"
        },
        {
          option_value: "YS",
          option_display: "Yes, sometimes"
        },
        {
          option_value: "YF",
          option_display: "Yes, frequently"
        }
      ],
      questionCode: "FQ8",
      questionId: 8,
      questionDisplayOrder: 8,
      languages: {
        hi: {
          questionDisplay: "क्या आप लोगों को खुलेआम सार्वजनिक जगहों पर या आस-पास शौच करते हुए देखते हैं?",
         optionValues: [
            {
              option_value: "NN",
              option_display: "नहीं, कभी नहीं"
            },
            {
              option_value: "YR",
              option_display: "हाँ, शायद ही कभी"
            },
            {
              option_value: "YS",
              option_display: "हाँ, कभी-कभी"
            },
            {
              option_value: "YF",
              option_display: "हाँ, अक्सर"
            }
          ]
        },
         pa: {
          questionDisplay: "ਕੀ ਤੁਸੀਂ ਲੋਕਾਂ ਨੂੰ ਜਨਤਕ ਜਾਂ ਨੇੜਲੇ ਖੇਤਰਾਂ ਵਿੱਚ ਖੁੱਲ੍ਹੇਆਮ ਪਿਸ਼ਾਬ ਕਰਦੇ ਜਾਂ ਮਲ-ਮੂਤਰ ਕਰਦੇ ਦੇਖਦੇ ਹੋ?",
         optionValues: [
            {
              option_value: "NN",
              option_display: "ਨਹੀਂ, ਕਦੇ ਨਹੀਂ"
            },
            {
              option_value: "YR",
              option_display: "ਹਾਂ, ਬਹੁਤ ਘੱਟ"
            },
            {
              option_value: "YS",
              option_display: "ਹਾਂ, ਕਈ ਵਾਰ"
            },
            {
              option_value: "YF",
              option_display: "ਹਾਂ, ਅਕਸਰ"
            }
          ]
        },
        te: {
          questionDisplay: "బహిరంగ/ పబ్లిక్ ప్రదేశాలలో లేదా సమీప ప్రాంతాలలో ప్రజలు బహిరంగంగా మూత్ర విసర్జన లేదా మల విసర్జన చేయడం మీరు చూశారా?",
         optionValues: [
            {
              option_value: "NN",
              option_display: "లేదు, ఎప్పుడూ చూడలేదు"
            },
            {
              option_value: "YR",
              option_display: "అవును, అరుదుగా"
            },
            {
              option_value: "YS",
              option_display: "అవును, కొన్నిసార్లు"
            },
            {
              option_value: "YF",
              option_display: "అవును, తరచుగా"
            }
          ]
        },
       as: {
          questionDisplay: "আপুনি ৰাজহুৱা বা আশ-পাশৰ স্থানত মানুহক মুকলিভাৱে প্ৰস্ৰাৱ কৰা বা শৌচ কৰা দেখিছে নেকি?",
         optionValues: [
            {
              option_value: "NN",
              option_display: "নহয়, কেতিয়াও নহয়"
            },
            {
              option_value: "YR",
              option_display: "হয়, কাচিৎহে"
            },
            {
              option_value: "YS",
              option_display: "হয়, কেতিয়াবা"
            },
            {
              option_value: "YF",
              option_display: "হয়, সঘনাই"
            }
          ]
        },
        or: {
          questionDisplay: "ଆପଣ କ’ଣ ଲୋକମାନଙ୍କୁ ସାର୍ବଜନୀନ(ପବ୍ଲିକ) କିମ୍ବା ନିକଟବର୍ତ୍ତୀ ଅଞ୍ଚଳରେ ଖୋଲାରେ ପରିସ୍ରା କିମ୍ବା ମଳତ୍ୟାଗ କରୁଥିବାର ଦେଖନ୍ତି?",
         optionValues: [
            {
              option_value: "NN",
              option_display: "ନା, କେବେବି ନୁହେଁ"
            },
            {
              option_value: "YR",
              option_display: "ହଁ, କ୍ୱଚିତ୍"
            },
            {
              option_value: "YS",
              option_display: "ହଁ, ବେଳେବେଳେ"
            },
            {
              option_value: "YF",
              option_display: "ହଁ, ପ୍ରାୟତଃ"
            }
          ]
        },
       mr: {
          questionDisplay: "तुम्हाला सार्वजनिक ठिकाणी किंवा जवळच्या परिसरात लोकं उघड्यावर लघवी करताना किंवा शौचास बसताना दिसतात का?",
         optionValues: [
            {
              option_value: "NN",
              option_display: "नाही, कधीच नाही"
            },
            {
              option_value: "YR",
              option_display: "होय, क्वचितच"
            },
            {
              option_value: "YS",
              option_display: "होय, कधीकधी"
            },
            {
              option_value: "YF",
              option_display: "होय, नेहमी"
            }
          ]
        },
      ka: {
          questionDisplay: "ನೀವು ಸಾರ್ವಜನಿಕ ಸ್ಥಳಗಳಲ್ಲಿ ಅಥವಾ ಹತ್ತಿರ ಪ್ರದೇಶದಲ್ಲಿ ಜನರು ಹೊಳೆ ಅಥವಾ ಶೌಚ ಮಾಡುತ್ತಿರುವುದನ್ನು ನೋಡುತ್ತೀರಾ?",
         optionValues: [
            {
              option_value: "NN",
              option_display: "ಎಂದಿಗೂ ಇಲ್ಲ"
            },
            {
              option_value: "YR",
              option_display: "ಬಹಳ ಕೆಲವೊಮ್ಮೆ"
            },
            {
              option_value: "YS",
              option_display: "ಕೆಲವೊಮ್ಮೆ"
            },
            {
              option_value: "YF",
              option_display: "ಹೆಚ್ಚಾಗಿ"
            }
          ]
        },
       bn: {
          questionDisplay: "আপনি কি লোকেদেরকে প্রকাশ্যে বা আশেপাশের এলাকায় প্রস্রাব বা মলত্যাগ করতে দেখেন?",
         optionValues: [
            {
              option_value: "NN",
              option_display: "না, কখনোই নয়"
            },
            {
              option_value: "YR",
              option_display: "হ্যাঁ, খুব কম"
            },
            {
              option_value: "YS",
              option_display: "হ্যাঁ, মাঝে-মধ্যে"
            },
            {
              option_value: "YF",
              option_display: "হ্যাঁ, ঘন ঘন"
            }
          ]
        },
       ta: {
          questionDisplay: "பொது இடங்களிலோ அல்லது அருகிலுள்ள பகுதிகளிலோ மக்கள் வெளிப்படையாக சிறுநீர் கழிப்பதையோ அல்லது மலம் கழிப்பதையோ நீங்கள் காண்கிறீர்களா?",
         optionValues: [
            {
              option_value: "NN",
              option_display: "இல்லை, ஒருபோதுமில்லை"
            },
            {
              option_value: "YR",
              option_display: "ஆம், அரிதாக"
            },
            {
              option_value: "YS",
              option_display: "ஆம், சில சமயங்களில்"
            },
            {
              option_value: "YF",
              option_display: "ஆம், அடிக்கடி"
            }
          ]
        },
        ur: {
          questionDisplay: "کیا آپ عوامی مقامات یا اپنے قریبی علاقوں میں لوگوں کو کھلے عام پیشاب یا رفعِ حاجت کرتے ہوئے دیکھتے ہیں؟",
         optionValues: [
            {
              option_value: "NN",
              option_display: "نہیں، کبھی نہیں"
            },
            {
              option_value: "YR",
              option_display: "جی ہاں، شاذ و نادر ہی"
            },
            {
              option_value: "YS",
              option_display: "جی ہاں، کبھی کبھار"
            },
            {
              option_value: "YF",
              option_display: "جی ہاں، اکثر"
            }
          ]
        },
        gu: {
          questionDisplay: "શું તમે લોકોને જાહેરમાં કે નજીકના વિસ્તારોમાં ખુલ્લામાં પેશાબ કરતા કે મળત્યાગ કરતા જુઓ છો?",
         optionValues: [
            {
              option_value: "NN",
              option_display: "ના, ક્યારેય નહી"
            },
            {
              option_value: "YR",
              option_display: "હા, ભાગ્યેજ"
            },
            {
              option_value: "YS",
              option_display: "હા, કેટલીકવાર"
            },
            {
              option_value: "YF",
              option_display: "હા, વારંવાર"
            }
          ]
        },
        ml: {
          questionDisplay: "പൊതുസ്ഥലങ്ങളിലോ സമീപ പ്രദേശങ്ങളിലോ പരസ്യമായി മൂത്രമൊഴിക്കുകയോ മലമൂത്ര വിസർജ്ജനം നടത്തുകയോ ചെയ്യുന്ന ആളുകളെ നിങ്ങൾ കാണുന്നുണ്ടോ?",
         optionValues: [
            {
              option_value: "NN",
              option_display: "ഇല്ല, ഒരിക്കലും"
            },
            {
              option_value: "YR",
              option_display: "അതെ, അപൂർവ്വമായി"
            },
            {
              option_value: "YS",
              option_display: "അതെ, ചിലപ്പോൾ"
            },
            {
              option_value: "YF",
              option_display: "അതെ, പലപ്പോഴും"
            }
          ]
        }
      }
    },
    {
      questionDisplay: "How satisfied are you with the cleanliness and maintenance of public toilets in your area?",
      optionType: "Single choice",
     optionValues: [
        {
          option_value: "VD",
          option_display: "Very Dissatisfied"
        },
        {
          option_value: "D",
          option_display: "Dissatisfied"
        },
        {
          option_value: "N",
          option_display: "Neutral"
        },
        {
          option_value: "S",
          option_display: "Satisfied"
        },
        {
          option_value: "VS",
          option_display: "Very Satisfied"
        },
        {
          option_value: "NU",
          option_display: "Have not used any public toilet recently"
        },
        {
          option_value: "NA",
          option_display: "No public toilet available in my area"
        }
      ],
      questionCode: "FQ9",
      questionId: 9,
      questionDisplayOrder: 9,
      languages: {
        hi: {
          questionDisplay: "आप अपने इलाके के सार्वजनिक शौचालय की सफाई और रख-रखाव से कितने संतुष्‍ट हैं?",
         optionValues: [
            {
              option_value: "VD",
              option_display: "बहुत असंतुष्ट"
            },
            {
              option_value: "D",
              option_display: "असंतुष्ट"
            },
            {
              option_value: "N",
              option_display: "तटस्थ"
            },
            {
              option_value: "S",
              option_display: "संतुष्ट"
            },
            {
              option_value: "VS",
              option_display: "बहुत संतुष्ट"
            },
            {
              option_value: "NU",
              option_display: "हाल ही में किसी सार्वजनिक शौचालय का इस्तेमाल नहीं किया"
            },
            {
              option_value: "NA",
              option_display: "मेरे इलाके में कोई सार्वजनिक शौचालय नहीं है"
            }
          ]
        },
         pa: {
          questionDisplay: "ਤੁਸੀਂ ਆਪਣੇ ਇਲਾਕੇ ਵਿੱਚ ਜਨਤਕ ਪਖਾਨਿਆਂ ਦੀ ਸਫਾਈ ਅਤੇ ਰੱਖ-ਰਖਾਅ ਤੋਂ ਕਿੰਨੇ ਸੰਤੁਸ਼ਟ ਹੋ?",
         optionValues: [
            {
              option_value: "VD",
              option_display: "ਬਹੁਤ ਅਸੰਤੁਸ਼ਟ"
            },
            {
              option_value: "D",
              option_display: "ਅਸੰਤੁਸ਼ਟ"
            },
            {
              option_value: "N",
              option_display: "ਨਿਰਪੱਖ"
            },
            {
              option_value: "S",
              option_display: "ਸੰਤੁਸ਼ਟ"
            },
            {
              option_value: "VS",
              option_display: "ਬਹੁਤ ਸੰਤੁਸ਼ਟ"
            },
            {
              option_value: "NU",
              option_display: "ਹਾਲ ਹੀ ਵਿੱਚ ਕੋਈ ਜਨਤਕ ਟਾਇਲਟ ਨਹੀਂ ਵਰਤਿਆ ਹੈ"
            },
            {
              option_value: "NA",
              option_display: "ਮੇਰੇ ਇਲਾਕੇ ਵਿੱਚ ਕੋਈ ਜਨਤਕ ਟਾਇਲਟ ਉਪਲਬਧ ਨਹੀਂ ਹੈ।"
            }
          ]
        },
        te: {
          questionDisplay: "మీ ప్రాంతంలోని పబ్లిక్ టాయిలెట్స్ యొక్క శుభ్రత మరియు వాటి నిర్వహణ పట్ల మీరు ఎంతవరకు సంతృప్తి చెందారు చెప్పండి?",
         optionValues: [
            {
              option_value: "VD",
              option_display: "చాలా అసంతృప్తి చెందాను"
            },
            {
              option_value: "D",
              option_display: "అసంతృప్తి చెందాను"
            },
            {
              option_value: "N",
              option_display: "తటస్థంగా ఉన్నాను"
            },
            {
              option_value: "S",
              option_display: "సంతృప్తి చెందాను"
            },
            {
              option_value: "VS",
              option_display: "చాలా సంతృప్తి చెందాను"
            },
            {
              option_value: "NU",
              option_display: "ఇటీవల ఏ పబ్లిక్ టాయిలెట్‌ను ఉపయోగించలేదు"
            },
            {
              option_value: "NA",
              option_display: "నా ప్రాంతంలో పబ్లిక్ టాయిలెట్‌ అందుబాటులో లేదు"
            }
          ]
        },
       as: {
          questionDisplay: "আপুনি আপোনাৰ অঞ্চলটোত ৰাজহুৱা শৌচাগাৰৰ পৰিষ্কাৰ-পৰিচ্ছন্নতা আৰু ৰক্ষণাবেক্ষণক লৈ  কিমান সন্তুষ্ট?",
         optionValues: [
            {
              option_value: "VD",
              option_display: "অত্যন্ত অসন্তুষ্ট"
            },
            {
              option_value: "D",
              option_display: "অসন্তুষ্ট"
            },
            {
              option_value: "N",
              option_display: "নিৰপেক্ষ"
            },
            {
              option_value: "S",
              option_display: "সন্তুষ্ট"
            },
            {
              option_value: "VS",
              option_display: "খুবেই সন্তুষ্ট"
            },
            {
              option_value: "NU",
              option_display: "শেহতীয়াকৈ কোনো ৰাজহুৱা শৌচাগাৰ ব্যৱহাৰ কৰা নাই"
            },
            {
              option_value: "NA",
              option_display: "মোৰ অঞ্চলত কোনো ৰাজহুৱা শৌচাগাৰ উপলব্ধ নাই"
            }
          ]
        },
        or: {
          questionDisplay: "ଆପଣଙ୍କ ଅଞ୍ଚଳରେ ସାର୍ବଜନୀନ ଶୌଚାଳୟର ପରିଷ୍କାର ପରିଚ୍ଛନ୍ନତା ଏବଂ ରକ୍ଷଣାବେକ୍ଷଣରେ ଆପଣ କେତେ ସନ୍ତୁଷ୍ଟ?",
         optionValues: [
            {
              option_value: "VD",
              option_display: "ଅତ୍ୟନ୍ତ ଅସନ୍ତୁଷ୍ଟ"
            },
            {
              option_value: "D",
              option_display: "ଅସନ୍ତୁଷ୍ଟ"
            },
            {
              option_value: "N",
              option_display: "ନିରପେକ୍ଷ"
            },
            {
              option_value: "S",
              option_display: "ସନ୍ତୁଷ୍ଟ"
            },
            {
              option_value: "VS",
              option_display: "ଅତ୍ୟନ୍ତ ସନ୍ତୁଷ୍ଟ"
            },
            {
              option_value: "NU",
              option_display: "ନିକଟ ଅତୀତରେ କୌଣସି ସାର୍ବଜନୀନ(ପବ୍ଲିକ) ଶୌଚାଳୟ ବ୍ୟବହାର କରିନାହାଁନ୍ତି"
            },
            {
              option_value: "NA",
              option_display: "ମୋ ଅଞ୍ଚଳରେ କୌଣସି ସାର୍ବଜନୀନ(ପବ୍ଲିକ) ଶୌଚାଳୟ ଉପଲବ୍ଧ ନାହିଁ।"
            }
          ]
        },
       mr: {
          questionDisplay: "तुमच्या परिसरातील सार्वजनिक शौचालयांच्या स्वच्छता आणि देखभालीशी तुम्ही किती समाधानी आहात?",
         optionValues: [
            {
              option_value: "VD",
              option_display: "खूप असमाधानी आहे"
            },
            {
              option_value: "D",
              option_display: "असमाधानी आहे"
            },
            {
              option_value: "N",
              option_display: "तटस्थ"
            },
            {
              option_value: "S",
              option_display: "समाधानी आहे"
            },
            {
              option_value: "VS",
              option_display: "खूप समाधानी आहे"
            },
            {
              option_value: "NU",
              option_display: "अलीकडेच कोणतेही सार्वजनिक शौचालय वापरलेले नाही"
            },
            {
              option_value: "NA",
              option_display: "माझ्या परिसरात कोणतेही सार्वजनिक शौचालय उपलब्ध नाही"
            }
          ]
        },
      ka: {
          questionDisplay: "ನಿಮ್ಮ ಪ್ರದೇಶದ ಸಾರ್ವಜನಿಕ ಶೌಚಾಲಯಗಳ ಸ್ವಚ್ಚತೆ ಮತ್ತು ನಿರ್ವಹಣೆಯಿಂದ ನೀವು ಎಷ್ಟು ತೃಪ್ತರಾಗಿದ್ದೀರಾ?",
         optionValues: [
            {
              option_value: "VD",
              option_display: "ತುಂಬಾ ಅಸಂತೋಷ"
            },
            {
              option_value: "D",
              option_display: "ಅಸಂತೋಷ"
            },
            {
              option_value: "N",
              option_display: "ತಟಸ್ಥ"
            },
            {
              option_value: "S",
              option_display: "ಸಂತೋಷ"
            },
            {
              option_value: "VS",
              option_display: "ತುಂಬಾ ಸಂತೋಷ"
            },
            {
              option_value: "NU",
              option_display: "ನಾನು ಇತ್ತೀಚೆಗೆ ಯಾವುದೇ ಸಾರ್ವಜನಿಕ ಶೌಚಾಲಯವನ್ನು ಬಳಸಿಲ್ಲ"
            },
            {
              option_value: "NA",
              option_display: "ನನ್ನ ಪ್ರದೇಶದಲ್ಲಿ ಯಾವುದೇ ಸಾರ್ವಜನಿಕ ಶೌಚಾಲಯವಿಲ್ಲ"
            }
          ]
        },
       bn: {
          questionDisplay: "আপনাদের এলাকায় সাধারন শৌচাগারের পরিচ্ছন্নতা এবং রক্ষনাবেক্ষনে আপনি কতটা সন্তুষ্ট?",
         optionValues: [
            {
              option_value: "VD",
              option_display: "খুব অসন্তুষ্ট"
            },
            {
              option_value: "D",
              option_display: "অসন্তুষ্ট"
            },
            {
              option_value: "N",
              option_display: "সন্তুষ্ট নয় আবার অসন্তুষ্ট নয়"
            },
            {
              option_value: "S",
              option_display: "সন্তুষ্ট  "
            },
            {
              option_value: "VS",
              option_display: "খুব সন্তুষ্ট"
            },
            {
              option_value: "NU",
              option_display: "সম্প্রতি কোনো সাধারন শৌচাগার ব্যবহার করিনি"
            },
            {
              option_value: "NA",
              option_display: "আমাদের এলাকায় কোনো সাধারন শৌচালয় নেই"
            }
          ]
        },
       ta: {
          questionDisplay: "உங்கள் பகுதியில் உள்ள பொதுக் கழிப்பறைகளின் தூய்மை மற்றும் பராமரிப்பு குறித்து நீங்கள் எந்தளவு திருப்தி அடைகிறீர்கள்?",
         optionValues: [
            {
              option_value: "VD",
              option_display: "மிகவும் திருப்பதியாக இல்லை"
            },
            {
              option_value: "D",
              option_display: "திருப்பதியாக இல்லை"
            },
            {
              option_value: "N",
              option_display: "நடுநிலை"
            },
            {
              option_value: "S",
              option_display: "திருப்பதியாக உள்ளது"
            },
            {
              option_value: "VS",
              option_display: "மிகவும் திருப்பதியாக உள்ளது"
            },
            {
              option_value: "NU",
              option_display: "சமீபத்தில் எந்த பொது கழிப்பறையையும் பயன்படுத்தவில்லை"
            },
            {
              option_value: "NA",
              option_display: "என்னுடைய பகுதியில் பொது கழிப்பறை எதுவுமில்லை"
            }
          ]
        },
        ur: {
          questionDisplay: "آپ اپنے علاقے میں عوامی بیت الخلا کی صفائی اور دیکھ بھال سے کتنے مطمئن ہیں؟",
         optionValues: [
            {
              option_value: "VD",
              option_display: "بہت غیر مطمئن"
            },
            {
              option_value: "D",
              option_display: "غیر مطمئن"
            },
            {
              option_value: "N",
              option_display: "غیر جانبدار"
            },
            {
              option_value: "S",
              option_display: "مطمئن"
            },
            {
              option_value: "VS",
              option_display: "بہت مطمئن"
            },
            {
              option_value: "NU",
              option_display: "حال ہی میں کسی عوامی بیت الخلا کا استعمال نہیں کیا"
            },
            {
              option_value: "NA",
              option_display: "میرے علاقے میں کوئی عوامی بیت الخلا دستیاب نہیں ہے"
            }
          ]
        },
        gu: {
          questionDisplay: "તમે તમારા વિસ્તારમાં જાહેર શૌચાલયોની સ્વચ્છતા અને જાળવણી સાથે કેટલા સંતુષ્ટ છો?",
         optionValues: [
            {
              option_value: "VD",
              option_display: "ખૂબજ અસંતુષ્ટ"
            },
            {
              option_value: "D",
              option_display: "અસંતુષ્ટ"
            },
            {
              option_value: "N",
              option_display: "તટસ્થ"
            },
            {
              option_value: "S",
              option_display: "સંતુષ્ટ"
            },
            {
              option_value: "VS",
              option_display: "ખૂબજ સંતુષ્ટ"
            },
            {
              option_value: "NU",
              option_display: "હાલમાં કોઈ જાહેર શૌચાલયનો ઉપયોગ કર્યો નથી"
            },
            {
              option_value: "NA",
              option_display: "મારા વિસ્તારમાં કોઈ જાહેર શૌચાલય ઉપલબ્ધ નથી."
            }
          ]
        },
        ml: {
          questionDisplay: "നിങ്ങളുടെ പ്രദേശത്തെ പൊതു ശൗചാലയങ്ങളുടെ ശുചിത്വത്തിലും പരിപാലനത്തിലും നിങ്ങൾ എത്രത്തോളം സംതൃപ്തനാണ്?",
         optionValues: [
            {
              option_value: "VD",
              option_display: "വളരെ അസംതൃപ്തി"
            },
            {
              option_value: "D",
              option_display: "അതൃപ്തി"
            },
            {
              option_value: "N",
              option_display: "നിഷ്പക്ഷത"
            },
            {
              option_value: "S",
              option_display: "തൃപ്തികരം"
            },
            {
              option_value: "VS",
              option_display: "വളരെ സംതൃപ്തി"
            },
            {
              option_value: "NU",
              option_display: "അടുത്തിടെ ഒരു പൊതു ടോയ്‌ലറ്റും ഉപയോഗിച്ചിട്ടില്ല"
            },
            {
              option_value: "NA",
              option_display: "എന്റെ പ്രദേശത്ത് പൊതു ടോയ്‌ലറ്റ് ലഭ്യമല്ല"
            }
          ]
        }
      }
    },
    {
      questionDisplay: "Are you aware of the Reduce, Reuse, Recycle (RRR) centers in your city for waste management?",
      optionType: "Single choice",
     optionValues: [
        {
          option_value: "Y_USED",
          option_display: "Yes, I know about them and have used their services"
        },
        {
          option_value: "Y_HEARD",
          option_display: "Yes, I have heard of them but never used their services"
        },
        {
          option_value: "N",
          option_display: "No, I am not aware of RRR centers"
        }
      ],
      questionCode: "FQ10",
      questionId: 10,
      questionDisplayOrder: 10,
      languages: {
        hi: {
          questionDisplay: "क्या आप अपने शहर में वेस्ट मैनेजमेंट के लिए रिड्यूस, रीयूज़, रीसाइकल (RRR) सेंटर के बारे में जानते हैं?",
         optionValues: [
            {
              option_value: "Y_USED",
              option_display: "हां, मैं उनके बारे में जानता हूं और उनकी सेवाओं को इस्‍तेमाल किया है"
            },
            {
              option_value: "Y_HEARD",
              option_display: "हां, मैंने उनके बारे में सुना है लेकिन कभी उनकी सर्विस इस्तेमाल नहीं किया।"
            },
            {
              option_value: "N",
              option_display: "नहीं, मैं आरआरआर सेंटर्स के बारे में नहीं जानता हूं"
            }
          ]
        },
         pa: {
          questionDisplay: "ਕੀ ਤੁਸੀਂ ਆਪਣੇ ਸ਼ਹਿਰ ਵਿੱਚ ਰਹਿੰਦ-ਖੂੰਹਦ ਪ੍ਰਬੰਧਨ ਲਈ ਰੀਡਿਊਸ, ਰੀਯੂਜ਼, ਰੀਸਾਈਕਲ (RRR) ਕੇਂਦਰਾਂ ਤੋਂ ਜਾਣੂ ਹੋ?",
         optionValues: [
            {
              option_value: "Y_USED",
              option_display: "ਹਾਂ, ਮੈਂ ਉਨ੍ਹਾਂ ਬਾਰੇ ਜਾਣਦਾ ਹਾਂ ਅਤੇ ਉਨ੍ਹਾਂ ਦੀਆਂ ਸੇਵਾਵਾਂ ਦੀ ਵਰਤੋਂ ਕੀਤੀ ਹੈ"
            },
            {
              option_value: "Y_HEARD",
              option_display: "ਹਾਂ, ਮੈਂ ਉਨ੍ਹਾਂ ਬਾਰੇ ਸੁਣਿਆ ਹੈ ਪਰ ਕਦੇ ਉਨ੍ਹਾਂ ਦੀਆਂ ਸੇਵਾਵਾਂ ਦੀ ਵਰਤੋਂ ਨਹੀਂ ਕੀਤੀ"
            },
            {
              option_value: "N",
              option_display: "ਨਹੀਂ, ਮੈਨੂੰ RRR ਕੇਂਦਰਾਂ ਬਾਰੇ ਪਤਾ ਨਹੀਂ ਹੈ।"
            }
          ]
        },
        te: {
          questionDisplay: "మీ నగరంలో వేస్ట్/ చెత్త వ్యర్థాలను మేనేజ్ చేయడం కోసం ఉన్న రెడ్యూస్, రీయూజ్, రీసైకిల్ (RRR) సెంటర్స్ గురించి మీకు తెలుసా?",
         optionValues: [
            {
              option_value: "Y_USED",
              option_display: "అవును, నాకు దాని గురించి తెలుసు మరియు వారి సర్వీసులను ఉపయోగించుకున్నాను."
            },
            {
              option_value: "Y_HEARD",
              option_display: "అవును, నేను దాని గురించి విన్నాను కానీ వారి సర్వీసులను ఎప్పుడూ ఉపయోగించలేదు."
            },
            {
              option_value: "N",
              option_display: "లేదు, నాకు RRR సెంటర్స్ గురించి తెలియదు."
            }
          ]
        },
       as: {
          questionDisplay: "আপুনি আপোনাৰ চহৰত আৱৰ্জনা ব্যৱস্থাপনাৰ বাবে থকা ৰিডিRRR) কেন্দ্ৰৰ বিষয়ে জানেনে?",
         optionValues: [
            {
              option_value: "Y_USED",
              option_display: "হয়, মই তেওঁলোকৰ বিষয়ে জানো আৰু তেওঁলোকৰ সেৱা ব্যৱহাৰ কৰিছো"
            },
            {
              option_value: "Y_HEARD",
              option_display: "হয়, মই তেওঁলোকৰ বিষয়ে শুনিছো কিন্তু তেওঁলোকৰ সেৱা কেতিয়াও ব্যৱহাৰ কৰা নাই"
            },
            {
              option_value: "N",
              option_display: "নহয়, মই RRR কেন্দ্ৰৰ বিষয়ে অৱগত নহয়"
            }
          ]
        },
        or: {
          questionDisplay: "ଆପଣଙ୍କ ସହରରେ ଥିବା ବର୍ଜ୍ୟବସ୍ତୁ ପରିଚାଳନା ପାଇଁ ରିଡ୍ୟୁସ୍, ରିୟୁଜ ଏବଂ ରିସାଇକେଲ  (RRR) କେନ୍ଦ୍ରଗୁଡ଼ିକ ବିଷୟରେ ଆପଣ ଜାଣନ୍ତି କି?",
         optionValues: [
            {
              option_value: "Y_USED",
              option_display: "ହଁ, ମୁଁ ସେମାନଙ୍କ ବିଷୟରେ ଜାଣିଛି ଏବଂ ସେମାନଙ୍କ ସେବା ବ୍ୟବହାର କରିଛି।"
            },
            {
              option_value: "Y_HEARD",
              option_display: "ହଁ, ମୁଁ ସେମାନଙ୍କ ବିଷୟରେ ଶୁଣିଛି କିନ୍ତୁ କେବେ ସେମାନଙ୍କ ସେବା ବ୍ୟବହାର କରିନାହିଁ।"
            },
            {
              option_value: "N",
              option_display: "ନା, ମୁଁ RRR କେନ୍ଦ୍ରଗୁଡ଼ିକ ବିଷୟରେ ଅବଗତ ନୁହେଁ।"
            }
          ]
        },
       mr: {
          questionDisplay: "तुम्हाला कचरा व्यवस्थापनेसाठी तुमच्या शहरातील रेड्यू, रियुज, रिसायकल (RRR) सेंटरविषयी माहित आहे का?",
         optionValues: [
            {
              option_value: "Y_USED",
              option_display: "होय, मला त्यांच्याविषयी माहित आहे आणि त्यांच्या सेवा वापरल्या आहेत"
            },
            {
              option_value: "Y_HEARD",
              option_display: "होय, मी त्यांच्याविषयी ऐकले आहे परंतु त्यांच्या सेवा कधीच वापरलेल्या नाही"
            },
            {
              option_value: "N",
              option_display: "नाही, मला RRR सेंटर्सविषयी माहित नाही"
            }
          ]
        },
      ka: {
          questionDisplay: "ನಗರದಲ್ಲಿ “ಕಡಿಮೆ ಮಾಡಿ, ಮರುಬಳಕೆ ಮಾಡಿ, ಮರುಪ್ರಯೋಜನೆ ಮಾಡಿ (RRR)” ಕೇಂದ್ರಗಳ ಬಗ್ಗೆ ನಿಮಗೆ ತಿಳಿದಿದೆಯೇ?",
         optionValues: [
            {
              option_value: "Y_USED",
              option_display: "ಹೌದು, ತಿಳಿದಿದೆ ಮತ್ತು ಸೇವೆ ಬಳಸಿದ್ದೇನೆ"
            },
            {
              option_value: "Y_HEARD",
              option_display: "ಹೌದು, ಕೇಳಿದ್ದೇನೆ ಆದರೆ ಬಳಸಿಲ್ಲ"
            },
            {
              option_value: "N",
              option_display: "ಇಲ್ಲ, RRR ಕೇಂದ್ರಗಳ ಬಗ್ಗೆ ತಿಳಿದಿಲ್ಲ"
            }
          ]
        },
       bn: {
          questionDisplay: "আপনি কি আবর্জনা ঠিকঠাকভাবে নিষ্পত্তি করার জন্য আপনার শহরে রিডিউস, রি ইউস, রিসাইকেল-এর ব্যাপারে জানেন?",
         optionValues: [
            {
              option_value: "Y_USED",
              option_display: "হ্যাঁ, আমি এ ব্যাপারে জানি এবং তাদের পরিসেবা ব্যবহার করেছি"
            },
            {
              option_value: "Y_HEARD",
              option_display: "হ্যাঁ, আমি এ ব্যাপারে শুনেছি কিন্তু তাদের পরিসেবা কখনো ব্যবহার করিনি"
            },
            {
              option_value: "N",
              option_display: "না, আমি আর আর আর সেন্টারগুলোর ব্যাপারে জানিনা"
            }
          ]
        },
       ta: {
          questionDisplay: "உங்கள் நகரத்தில் கழிவு மேலாண்மைக்காகச் செயல்படும் 'குறைத்தல், மறுபயன்பாடு, மறுசுழற்சி' (RRR) மையங்களைப் பற்றி நீங்கள் அறிந்துள்ளீர்களா?",
         optionValues: [
            {
              option_value: "Y_USED",
              option_display: "ஆம், அவற்றைப் பற்றி நான் அறிந்துள்ளேன் மேலும் அவர்களுடைய சர்வீஸ்களை (சேவைகளை) பயன்படுத்தியுள்ளேன்"
            },
            {
              option_value: "Y_HEARD",
              option_display: "ஆம், அவற்றைப் பற்றி நான் கேள்விப்பட்டுள்ளேன் ஆனால் அவர்களுடைய சர்வீஸ்களை (சேவைகளை) ஒருபோதும் பயன்படுத்தவில்லை"
            },
            {
              option_value: "N",
              option_display: "இல்லை, நான் RRR மையங்களைப் பற்றி அறியவில்லை"
            }
          ]
        },
        ur: {
          questionDisplay: "کیا آپ اپنے شہر میں کچرے کے انتظام کے لیے Reduce, Reuse, Recycle (RRR) مراکز کے بارے میں آگاہ ہیں",
         optionValues: [
            {
              option_value: "Y_USED",
              option_display: "میرے علاقے میں کوئی عوامی بیت الخلا دستیاب نہیں ہے"
            },
            {
              option_value: "Y_HEARD",
              option_display: "جی ہاں، میں نے ان کے بارے میں سنا ہے لیکن کبھی ان کی خدمات استعمال نہیں کیں"
            },
            {
              option_value: "N",
              option_display: "نہیں، میں RRR مراکز کے بارے میں آگاہ نہیں ہوں"
            }
          ]
        },
        gu: {
          questionDisplay: "શું તમે તમારા શહેરમાં કચરાના મેનેજમેન્ટ/સંચાલન માટે રિડ્યુસ, રિયુઝ, રિસાયકલ (RRR) સેન્ટર્સ વિશે જાણો છો?",
         optionValues: [
            {
              option_value: "Y_USED",
              option_display: "હા, હું તેમના વિશે જાણું છું અને તેઓની સેવાઓનો ઉપયોગ કર્યો છે"
            },
            {
              option_value: "Y_HEARD",
              option_display: "હા, મેં તેના વિશે સાંભળ્યું છે પણ ક્યારેય તેમની સેવાઓનો ઉપયોગ કર્યો નથી"
            },
            {
              option_value: "N",
              option_display: "ના, હું RRR સેન્ટર્સ વિશે જાણતો નથી."
            }
          ]
        },
        ml: {
          questionDisplay: "നിങ്ങളുടെ നഗരത്തിലെ മാലിന്യ സംസ്കരണത്തിനായുള്ള റെഡ്യൂസ്, റീയൂസ്, റീസൈക്കിൾ (RRR) കേന്ദ്രങ്ങളെക്കുറിച്ച് നിങ്ങൾക്ക് അറിയാമോ?",
         optionValues: [
            {
              option_value: "Y_USED",
              option_display: "അതെ, എനിക്ക് അവരെക്കുറിച്ച് അറിയാം, അവരുടെ സേവനങ്ങൾ ഉപയോഗിച്ചിട്ടുമുണ്ട്"
            },
            {
              option_value: "Y_HEARD",
              option_display: "അതെ, ഞാൻ അവരെക്കുറിച്ച് കേട്ടിട്ടുണ്ട്, പക്ഷേ അവരുടെ സേവനങ്ങൾ ഒരിക്കലും ഉപയോഗിച്ചിട്ടില്ല"
            },
            {
              option_value: "N",
              option_display: "ഇല്ല, എനിക്ക് RRR കേന്ദ്രങ്ങളെക്കുറിച്ച് അറിയില്ല"
            }
          ]
        }
      }
    },
    {
      questionDisplay: "Who do you contact when your sewer or septic tank needs cleaning?",
      optionType: "Single choice",
     optionValues: [
        {
          option_value: "ULB",
          option_display: "Local Municipality / ULB"
        },
        {
          option_value: "PLC",
          option_display: "Private Licensed Operator/Contractor"
        },
        {
          option_value: "PIL",
          option_display: "Private Individual / Local Laborer"
        }
      ],
      questionCode: "FQ11",
      questionId: 11,
      questionDisplayOrder: 11,
      languages: {
        hi: {
          questionDisplay: "जब आपके सीवर या सेप्टिक टैंक को सफाई की ज़रूरत होती है तो आप किससे संपर्क करते हैं?",
         optionValues: [
            {
              option_value: "ULB",
              option_display: "स्थानीय नगर पालिका / यूएलबी"
            },
            {
              option_value: "PLC",
              option_display: "प्राइवेट लाइसेंस प्राप्त ऑपरेटर/ठेकेदार"
            },
            {
              option_value: "PIL",
              option_display: "निजी व्यक्ति / स्थानीय मजदूर"
            }
          ]
        },
         pa: {
          questionDisplay: "ਜਦੋਂ ਤੁਹਾਡੇ ਸੀਵਰ ਜਾਂ ਸੈਪਟਿਕ ਟੈਂਕ ਨੂੰ ਸਾਫ਼ ਕਰਨ ਦੀ ਲੋੜ ਹੁੰਦੀ ਹੈ ਤਾਂ ਤੁਸੀਂ ਕਿਸ ਨਾਲ ਸੰਪਰਕ ਕਰਦੇ ਹੋ?",
         optionValues: [
            {
              option_value: "ULB",
              option_display: "ਸਥਾਨਕ ਨਗਰਪਾਲਿਕਾ / ਯੂਐਲਬੀ"
            },
            {
              option_value: "PLC",
              option_display: "ਨਿੱਜੀ ਲਾਇਸੰਸਸ਼ੁਦਾ ਆਪਰੇਟਰ / ਠੇਕੇਦਾਰ"
            },
            {
              option_value: "PIL",
              option_display: "ਨਿੱਜੀ ਵਿਅਕਤੀ / ਸਥਾਨਕ ਮਜ਼ਦੂਰ"
            }
          ]
        },
        te: {
          questionDisplay: "మీ మురుగునీటి కాలువ లేదా సెప్టిక్ ట్యాంక్‌ను శుభ్రపరచాల్సి వచ్చినప్పుడు మీరు ఎవరిని సంప్రదిస్తారు?",
         optionValues: [
            {
              option_value: "ULB",
              option_display: "లోకల్ మున్సిపాలిటీ / పట్టణ స్థానిక సంస్థ (ULB)"
            },
            {
              option_value: "PLC",
              option_display: "ప్రైవేట్ లైసెన్స్ పొందిన ఆపరేటర్/ కాంట్రాక్టర్"
            },
            {
              option_value: "PIL",
              option_display: "ప్రైవేట్ వ్యక్తి / స్థానిక కార్మికుడు (లోకల్ లేబర్)"
            }
          ]
        },
       as: {
          questionDisplay: "যেতিয়া আপোনাৰ নলা-নৰ্দমা বা চেপ্টিক টেংক পৰিষ্কাৰ কৰাৰ প্ৰয়োজন হয় তেতিয়া আপুনি কাৰ সৈতে যোগাযোগ কৰিব?",
         optionValues: [
            {
              option_value: "ULB",
              option_display: "স্থানীয় পৌৰসভা/ULB"
            },
            {
              option_value: "PLC",
              option_display: "ব্যক্তিগত অনুজ্ঞাপত্ৰপ্ৰাপ্ত অপাৰেটৰ/ঠিকাদাৰ"
            },
            {
              option_value: "PIL",
              option_display: "ব্যক্তিগত/স্থানীয় শ্ৰমিক"
            }
          ]
        },
        or: {
          questionDisplay: "ଯେତେବେଳେ ଆପଣଙ୍କର ସ୍ୱେରେଜ୍ କିମ୍ବା ସେପ୍ଟିକ୍ ଟାଙ୍କି ସଫା କରିବାର ଆବଶ୍ୟକତା ଥାଏ, ସେତେବେଳେ ଆପଣ କାହା ସହିତ ଯୋଗାଯୋଗ କରନ୍ତି?",
         optionValues: [
            {
              option_value: "ULB",
              option_display: "ସ୍ଥାନୀୟ ପୌରପାଳିକା / ULB"
            },
            {
              option_value: "PLC",
              option_display: "ଘରୋଇ ଲାଇସେନ୍ସପ୍ରାପ୍ତ ଅପରେଟର/ଠିକାଦାର"
            },
            {
              option_value: "PIL",
              option_display: "ବ୍ୟକ୍ତିଗତ ବ୍ୟକ୍ତି / ସ୍ଥାନୀୟ ଶ୍ରମିକ"
            }
          ]
        },
       mr: {
          questionDisplay: "तुम्हाला तुमचे गटार किंवा सेप्टिक टँक स्वच्छ करायचे असते तेव्हा तुम्ही कोणाला संपर्क साधता?",
         optionValues: [
            {
              option_value: "ULB",
              option_display: "स्थानिक नगरपालिका/ युएलबी"
            },
            {
              option_value: "PLC",
              option_display: "प्रायवेट लायसन्स्ड ऑपरेटर/कॉन्ट्रॅक्टर"
            },
            {
              option_value: "PIL",
              option_display: "प्रायवेट व्यक्ती/ स्थानिक मजूर"
            }
          ]
        },
      ka: {
          questionDisplay: "ನಿಮ್ಮ ನವೀನ/ಸೇಪ್ಟಿಕ್ ಟ್ಯಾಂಕ್ ಶುದ್ಧೀಕರಣಕ್ಕೆ ನೀವು ಯಾರನ್ನು ಸಂಪರ್ಕಿಸುತ್ತೀರಿ?",
         optionValues: [
            {
              option_value: "ULB",
              option_display: "ಸ್ಥಳೀಯ ಮಹಾನಗರ ಪಾಲಿಕೆ"
            },
            {
              option_value: "PLC",
              option_display: "ಖಾಸಗಿ ಪರವಾನಗಿ ಪಡೆದ ಸಂಚಾಲಕ"
            },
            {
              option_value: "PIL",
              option_display: "ಖಾಸಗಿ ವ್ಯಕ್ತಿ / ಸ್ಥಳೀಯ ಕಾರ್ಮಿಕ"
            }
          ]
        },
       bn: {
          questionDisplay: "আপনার নর্দমা বা সেপটিক ট্যাঙ্ক পরিষ্কার করার প্রয়োজন হলে আপনি কার সাথে যোগাযোগ করেন?",
         optionValues: [
            {
              option_value: "ULB",
              option_display: "স্থানীয় পৌরসভা/ ইউ এল বি"
            },
            {
              option_value: "PLC",
              option_display: "বেসরকারি লাইসেন্সযুক্ত অপারেটর/ কনট্রাক্টর"
            },
            {
              option_value: "PIL",
              option_display: "বেসরকারি ব্যক্তি/ স্থানীয় শ্রমিক"
            }
          ]
        },
       ta: {
          questionDisplay: "உங்கள் கழிவுநீர் வடிகால் அல்லது செப்டிக் தொட்டியை சுத்தம் செய்ய வேண்டியிருக்கும் போது நீங்கள் யாரை தொடர்பு கொள்கிறீர்கள்?",
         optionValues: [
            {
              option_value: "ULB",
              option_display: "உள்ளூர் நகராட்சி / நகர்ப்புற உள்ளாட்சி அமைப்பு (ULB)"
            },
            {
              option_value: "PLC",
              option_display: "தனியார் உரிமம் பெற்ற ஆப்பரேட்டர் / கான்ட்ராக்டர்"
            },
            {
              option_value: "PIL",
              option_display: "தனிநபர் / உள்ளூர் தொழிலாளி"
            }
          ]
        },
        ur: {
          questionDisplay: "جب آپ کے سیور یا سیپٹک ٹینک کی صفائی کی ضرورت ہو تو آپ کس سے رابطہ کرتے ہیں؟",
         optionValues: [
            {
              option_value: "ULB",
              option_display: "مقامی بلدیہ / شہری بلدیاتی ادارہ (ULB)"
            },
            {
              option_value: "PLC",
              option_display: "نجی لائسنس یافتہ آپریٹر / ٹھیکیدار"
            },
            {
              option_value: "PIL",
              option_display: "نجی فرد / مقامی مزدور"
            }
          ]
        },
        gu: {
          questionDisplay: "જ્યારે તમારા ગટર કે સેપ્ટિક ટાંકીને સાફ કરવાની જરૂર હોય ત્યારે તમે કોનો સંપર્ક કરો છો?",
         optionValues: [
            {
              option_value: "ULB",
              option_display: "સ્થાનિક મ્યુનિસિપાલિટી / યુએલબી"
            },
            {
              option_value: "PLC",
              option_display: "ખાનગી લાઇસન્સ પ્રાપ્ત ઓપરેટર/કોન્ટ્રાક્ટર"
            },
            {
              option_value: "PIL",
              option_display: "ખાનગી વ્યક્તિ / સ્થાનિક મજૂર"
            }
          ]
        },
        ml: {
          questionDisplay: "നിങ്ങളുടെ അഴുക്കുചാലോ സെപ്റ്റിക് ടാങ്കോ വൃത്തിയാക്കേണ്ടി വരുമ്പോൾ നിങ്ങൾ ആരെയാണ് ബന്ധപ്പെടേണ്ടത്?",
         optionValues: [
            {
              option_value: "ULB",
              option_display: "ലോക്കൽ മുനിസിപ്പാലിറ്റി / ULB"
            },
            {
              option_value: "PLC",
              option_display: "സ്വകാര്യ ലൈസൻസുള്ള ഓപ്പറേറ്റർ/കോൺട്രാക്ടർ"
            },
            {
              option_value: "PIL",
              option_display: "സ്വകാര്യ വ്യക്തി / തദ്ദേശ തൊഴിലാളി"
            }
          ]
        }
      }
    },
    {
      questionDisplay: "How do you report cleanliness-related issues (e.g., garbage dumping, overflowing bins, lack of sanitation) to the local authorities?",
      optionType: "Single choice",
     optionValues: [
        {
          option_value: "APP_SW",
          option_display: "I use the Swachhata App"
        },
        {
          option_value: "APP_LOCAL",
          option_display: "I use a local city app"
        },
        {
          option_value: "OTHER",
          option_display: "I use other mode such as helpline number/portal, social media etc."
        },
        {
          option_value: "NONE_EFFECTIVE",
          option_display: "No grievance redressal mechanism works effectively"
        },
        {
          option_value: "UNAWARE",
          option_display: "I am not aware of any Grievance Redressal Mechanism"
        }
      ],
      questionCode: "FQ12",
      questionId: 12,
      questionDisplayOrder: 12,
      languages: {
        hi: {
          questionDisplay: "आप लोकल अधिकारियों को सफ़ाई से जुड़ी समस्‍यायें (जैसे, कचरा फेंकना, कूड़ेदानों का ओवरफ्लो होना, साफ़-सफ़ाई की कमी) को कैसे बताते हैं?",
         optionValues: [
            {
              option_value: "APP_SW",
              option_display: "मैं स्वच्छता ऐप का इस्तेमाल करता हूँ"
            },
            {
              option_value: "APP_LOCAL",
              option_display: "मैं एक लोकल सिटी ऐप इस्तेमाल करता हूँ"
            },
            {
              option_value: "OTHER",
              option_display: "मैं दूसरे तरीकों का इस्तेमाल करता हूँ जैसे हेल्पलाइन नंबर/पोर्टल, सोशल मीडिया आदि"
            },
            {
              option_value: "NONE_EFFECTIVE",
              option_display: "कोई भी शिकायत निवारण तंत्र प्रभावी ढंग से काम नहीं करता है"
            },
            {
              option_value: "UNAWARE",
              option_display: "मैं किसी शिकायत निवारण तंत्र के बारे में नहीं जानता हूं"
            }
          ]
        },
         pa: {
          questionDisplay: "ਤੁਸੀਂ ਸਫਾਈ ਨਾਲ ਸਬੰਧਤ ਮੁੱਦਿਆਂ (ਜਿਵੇਂ ਕਿ ਕੂੜਾ ਸੁੱਟਣਾ, ਭਰੇ ਹੋਏ ਡੱਬੇ, ਸਫਾਈ ਦੀ ਘਾਟ) ਦੀ ਰਿਪੋਰਟ ਸਥਾਨਕ ਅਧਿਕਾਰੀਆਂ ਨੂੰ ਕਿਵੇਂ ਕਰਦੇ ਹੋ?",
         optionValues: [
            {
              option_value: "APP_SW",
              option_display: "ਮੈਂ ਸਵੱਛਤਾ ਐਪ ਦੀ ਵਰਤੋਂ ਕਰਦਾ ਹਾਂ"
            },
            {
              option_value: "APP_LOCAL",
              option_display: "ਮੈਂ ਇੱਕ ਸਥਾਨਕ ਸ਼ਹਿਰ ਦੀ ਐਪ ਦੀ ਵਰਤੋਂ ਕਰਦਾ ਹਾਂ"
            },
            {
              option_value: "OTHER",
              option_display: "ਮੈਂ ਹੋਰ ਢੰਗਾਂ ਦੀ ਵਰਤੋਂ ਕਰਦਾ ਹਾਂ ਜਿਵੇਂ ਕਿ ਹੈਲਪਲਾਈਨ ਨੰਬਰ/ਪੋਰਟਲ, ਸੋਸ਼ਲ ਮੀਡੀਆ ਆਦਿ।"
            },
            {
              option_value: "NONE_EFFECTIVE",
              option_display: "ਕੋਈ ਵੀ ਸ਼ਿਕਾਇਤ ਨਿਵਾਰਣ ਵਿਧੀ ਪ੍ਰਭਾਵਸ਼ਾਲੀ ਢੰਗ ਨਾਲ ਕੰਮ ਨਹੀਂ ਕਰਦੀ"
            },
            {
              option_value: "UNAWARE",
              option_display: "ਮੈਨੂੰ ਕਿਸੇ ਸ਼ਿਕਾਇਤ ਨਿਵਾਰਣ ਵਿਧੀ ਬਾਰੇ ਜਾਣਕਾਰੀ ਨਹੀਂ ਹੈ।"
            }
          ]
        },
        te: {
          questionDisplay: "పరిశుభ్రతకు సంబంధించిన సమస్యలను (ఉదా: చెత్త డంప్ చేయడం, డస్ట్ బిన్స్ నిండిపోవడం, శానిటేషన్ లోపం) మీరు స్థానిక అధికారులకు ఎలా రిపోర్ట్ చేస్తారు?",
         optionValues: [
            {
              option_value: "APP_SW",
              option_display: "నేను స్వచ్ఛత యాప్‌ను ఉపయోగిస్తాను"
            },
            {
              option_value: "APP_LOCAL",
              option_display: "నేను లోకల్ సిటీ యాప్‌ను ఉపయోగిస్తాను"
            },
            {
              option_value: "OTHER",
              option_display: "నేను హెల్ప్‌లైన్ నంబర్/ పోర్టల్, సోషల్ మీడియా మొదలైన ఇతర మార్గాలను ఉపయోగిస్తాను."
            },
            {
              option_value: "NONE_EFFECTIVE",
              option_display: "ఏ ఫిర్యాదుల పరిష్కార యంత్రాంగం కూడా సమర్థవంతంగా పనిచేయదు"
            },
            {
              option_value: "UNAWARE",
              option_display: "నాకు ఎలాంటి ఫిర్యాదుల పరిష్కార యంత్రాంగం గురించి తెలియదు"
            }
          ]
        },
       as: {
          questionDisplay: "আপুনি কেনেকৈ পৰিষ্কাৰ-পৰিচ্ছন্নতা সম্পৰ্কীয় সমস্যাবোৰ (যেনে, আৱৰ্জনা ডাম্পিং, উপচি পৰা বিন, অনাময় ব্যৱস্থাৰ অভাৱ) স্থানীয় কৰ্তৃপক্ষক অৱগত কৰে?",
         optionValues: [
            {
              option_value: "APP_SW",
              option_display: "মই স্বচ্ছতা এপ্পটো ব্যৱহাৰ কৰোঁ"
            },
            {
              option_value: "APP_LOCAL",
              option_display: "মই এটা স্থানীয় চহৰৰ এপ্প ব্যৱহাৰ কৰোঁ"
            },
            {
              option_value: "OTHER",
              option_display: "মই হেল্প লাইন নম্বৰ/পৰ্টেল, ছচিয়েল মিডিয়া আদিৰ দৰে অন্য়ান্য মাধ্যম ব্যৱহাৰ কৰো।"
            },
            {
              option_value: "NONE_EFFECTIVE",
              option_display: "কোনো অভিযোগ নিষ্পত্তি ব্যৱস্থাই ফলপ্ৰসূভাৱে কাম কৰা নাই"
            },
            {
              option_value: "UNAWARE",
              option_display: "মই কোনো অভিযোগ নিষ্পত্তি ব্যৱস্থাৰ বিষয়ে অৱগত নহয়"
            }
          ]
        },
        or: {
          questionDisplay: "ଆପଣ ସ୍ଥାନୀୟ କର୍ତ୍ତୃପକ୍ଷଙ୍କୁ ପରିଷ୍କାର ପରିଚ୍ଛନ୍ନତା ସମ୍ବନ୍ଧୀୟ ସମସ୍ୟାଗୁଡ଼ିକ (ଯଥା, ଅଳିଆ ଆବର୍ଜନା, ଓଭରଫ୍ଳୋ ଡଷ୍ଟବିନ, ପରିମଳ ବ୍ୟବସ୍ଥାର ଅଭାବ) କିପରି ରିପୋର୍ଟ କରିବେ?",
         optionValues: [
            {
              option_value: "APP_SW",
              option_display: "ମୁଁ ସ୍ୱଚ୍ଛତା ଆପ୍ ବ୍ୟବହାର କରେ ।"
            },
            {
              option_value: "APP_LOCAL",
              option_display: "ମୁଁ ଏକ ସ୍ଥାନୀୟ ସହର ଆପ୍ ବ୍ୟବହାର କରେ ।"
            },
            {
              option_value: "OTHER",
              option_display: "ମୁଁ ହେଲ୍ପଲାଇନ୍ ନମ୍ବର/ପୋର୍ଟାଲ୍, ସୋସିଆଲ ମିଡିଆ ଇତ୍ୟାଦି ଅନ୍ୟାନ୍ୟ ଉପାୟ ବ୍ୟବହାର କରେ।"
            },
            {
              option_value: "NONE_EFFECTIVE",
              option_display: "କୌଣସି ଅଭିଯୋଗ ସମାଧାନ ବ୍ୟବସ୍ଥା ପ୍ରଭାବଶାଳୀ ଭାବରେ କାମ କରୁନାହିଁ।"
            },
            {
              option_value: "UNAWARE",
              option_display: "ମୁଁ କୌଣସି ଅଭିଯୋଗ ସମାଧାନ ବ୍ୟବସ୍ଥା ବିଷୟରେ ଅବଗତ ନୁହେଁ।"
            }
          ]
        },
       mr: {
          questionDisplay: "स्वच्छतेशी संबंधित समस्यांची (उदा. कचरा साचणे, कचरा कुंड्या ओसंडून वाहणे, स्वच्छतेचा अभाव) स्थानिक प्रशासनाकडे तुम्ही कशी तक्रार करता?",
         optionValues: [
            {
              option_value: "APP_SW",
              option_display: "मी स्वच्छता ॲप वापरतो/वापरते"
            },
            {
              option_value: "APP_LOCAL",
              option_display: "मी लोकल सिटी ॲप वापरतो/वापरते"
            },
            {
              option_value: "OTHER",
              option_display: "मी इतर माध्यम वापरतो/वापरते जसे हेल्पलाइन क्रमांक/ पोर्टल, सोशल मीडिया इत्यादी"
            },
            {
              option_value: "NONE_EFFECTIVE",
              option_display: "कोणतीही तक्रार निवारण व्यवस्था परिणामकारकपणे काम करत नाही"
            },
            {
              option_value: "UNAWARE",
              option_display: "मला कोणत्याही तक्रार निवारण व्यवस्थेविषयी माहित नाही"
            }
          ]
        },
      ka: {
          questionDisplay: "ಸ್ವಚ್ಚತೆಯ ಸಂಬಂಧಿತ ಸಮಸ್ಯೆಗಳನ್ನು (ಉದಾ: ಕಸ ಸುರಿದುಹಾಕುವುದು, ತುಂಬಿರುವ ಬಿನ್‌ಗಳು, ಶೌಚಾಲಯ ಕೊರತೆ) ಸ್ಥಳೀಯ ಅಧಿಕಾರಿಗಳಿಗೆ ನೀವು ಹೇಗೆ ವರದಿ ಮಾಡುತ್ತೀರಿ?",
         optionValues: [
            {
              option_value: "APP_SW",
              option_display: "ಸ್ವಚ್ಛತಾ ಆ್ಯಪ್ ಬಳಕೆ"
            },
            {
              option_value: "APP_LOCAL",
              option_display: "ಸ್ಥಳೀಯ ನಗರ ಆ್ಯಪ್ ಬಳಕೆ"
            },
            {
              option_value: "OTHER",
              option_display: "ನಾನು ಹೆಲ್ಪ್‌ಲೈನ್ ಸಂಖ್ಯೆ/ಪೋರ್ಟಲ್, ಸಾಮಾಜಿಕ ಮಾಧ್ಯಮ ಇತ್ಯಾದಿ ಇತರ ವಿಧಾನಗಳನ್ನು ಬಳಸುತ್ತೇನೆ."
            },
            {
              option_value: "NONE_EFFECTIVE",
              option_display: "ಯಾವುದೇ ದೂರು ಪರಿಹಾರ ವ್ಯವಸ್ಥೆಯೂ ಪರಿಣಾಮಕಾರಿಯಾಗಿ ಕೆಲಸ ಮಾಡುತ್ತಿಲ್ಲ"
            },
            {
              option_value: "UNAWARE",
              option_display: "ಯಾವುದೇ ದೂರು ಪರಿಹಾರ ವ್ಯವಸ್ಥೆಯ ಬಗ್ಗೆ ನನಗೆ ತಿಳಿದಿಲ್ಲ"
            }
          ]
        },
       bn: {
          questionDisplay: " আপনি কিভাবে স্থানীয় কর্তৃপক্ষকে পরিচ্ছন্নতা সংক্রান্ত সমস্যা (যেমন- আবর্জনা জমা থাকা, বিন উপচে পড়া, পরিচ্ছন্নতার অভাব) রিপোর্ট করেন?",
         optionValues: [
            {
              option_value: "APP_SW",
              option_display: "আমি স্বচ্ছতা অ্যাপ ব্যবহার করি"
            },
            {
              option_value: "APP_LOCAL",
              option_display: "আমি স্থানীয় শহরের অ্যাপ ব্যবহার করি"
            },
            {
              option_value: "OTHER",
              option_display: "আমি অন্য মাধ্যম ব্যবহার করি যেমন- হেল্পলাইন নম্বর/ পোর্টাল, সোসাল মিডিয়া ইত্যাদি."
            },
            {
              option_value: "NONE_EFFECTIVE",
              option_display: "কোনো অভিযোগ মেটানোর ব্যবস্থা কার্যকরভাবে কাজ করে না"
            },
            {
              option_value: "UNAWARE",
              option_display: " আমি কোনো অভিযোগ মেটানোর ব্যবস্থার ব্যাপারে জানি না"
            }
          ]
        },
       ta: {
          questionDisplay: "சுத்தம் தொடர்பான பிரச்சனைகளை (எ.கா: குப்பை கொட்டுதல், குப்பைத் தொட்டிகள் நிரம்பி வழிதல், சுகாதாரமின்மை) உள்ளூர் அதிகாரிகளிடம் நீங்கள் எவ்வாறு தெரிவிக்கிறீர்கள்?",
         optionValues: [
            {
              option_value: "APP_SW",
              option_display: "நான் ஸ்வச்சதா ஆப்-ஐ பயன்படுத்துகிறேன்"
            },
            {
              option_value: "APP_LOCAL",
              option_display: "நான் உள்ளூர் நகர ஆப்-ஐ பயன்படுத்துகிறேன்"
            },
            {
              option_value: "OTHER",
              option_display: "நான் உதவி எண், இணையதளம், சோஷியல் மீடியா போன்ற பிற வழிமுறைகளை பயன்படுத்துகிறேன்"
            },
            {
              option_value: "NONE_EFFECTIVE",
              option_display: "எந்தவொரு குறை தீர்க்கும் வழிமுறையும் திறம்பட செயல்படுவதில்லை"
            },
            {
              option_value: "UNAWARE",
              option_display: "எந்தவொரு குறை தீர்க்கும் வழிமுறையை பற்றியும் நான் அறியவில்லை"
            }
          ]
        },
        ur: {
          questionDisplay: "آپ صفائی سے متعلق مسائل (مثلاً کچرا پھینکنا، بھرے ہوئے ڈبے، صفائی کی کمی) کی اطلاع مقامی حکام کو کیسے دیتے ہیں",
         optionValues: [
            {
              option_value: "APP_SW",
              option_display: "میں سوچھتا ایپ استعمال کرتا/کرتی ہوں"
            },
            {
              option_value: "APP_LOCAL",
              option_display: "میں مقامی شہر کی ایپ استعمال کرتا/کرتی ہوں"
            },
            {
              option_value: "OTHER",
              option_display: "میں دیگر طریقے استعمال کرتا/کرتی ہوں جیسے ہیلپ لائن نمبر/پورٹل، سوشل میڈیا وغیرہ"
            },
            {
              option_value: "NONE_EFFECTIVE",
              option_display: "کوئی بھی شکایت کے ازالے کا نظام مؤثر طریقے سے کام نہیں کرتا"
            },
            {
              option_value: "UNAWARE",
              option_display: "میں کسی بھی شکایت کے ازالے کے نظام سے آگاہ نہیں ہوں"
            }
          ]
        },
        gu: {
          questionDisplay: "તમે સ્થાનિક અધિકારીઓને સ્વચ્છતા સંબંધિત સમસ્યાઓ (દા.ત., કચરો ફેંકવો, ભરાયેલા ડબ્બા, સ્વચ્છતાનો અભાવ) વિશે કેવી રીતે જાણ કરો છો?",
         optionValues: [
            {
              option_value: "APP_SW",
              option_display: "હું સ્વચ્છતા એપનો ઉપયોગ કરું છું"
            },
            {
              option_value: "APP_LOCAL",
              option_display: "હું સ્થાનિક શહેરની એપનો ઉપયોગ કરું છું"
            },
            {
              option_value: "OTHER",
              option_display: "હું હેલ્પલાઇન નંબર/પોર્ટલ, સોશિયલ મીડિયા વગેરે જેવા અન્ય માધ્યમોનો ઉપયોગ કરું છું."
            },
            {
              option_value: "NONE_EFFECTIVE",
              option_display: "કોઈ ફરિયાદ નિવારણ પદ્ધતિ અસરકારક રીતે કામ કરતી નથી"
            },
            {
              option_value: "UNAWARE",
              option_display: "હું કોઈપણ ફરિયાદ નિવારણ પદ્ધતિ વિશે જાણતો નથી"
            }
          ]
        },
        ml: {
          questionDisplay: "ശുചിത്വവുമായി ബന്ധപ്പെട്ട പ്രശ്നങ്ങൾ (ഉദാ: മാലിന്യ നിക്ഷേപം, നിറഞ്ഞുകവിഞ്ഞ ബിന്നുകൾ, ശുചിത്വക്കുറവ്) തദ്ദേശ സ്വയംഭരണ സ്ഥാപനങ്ങളെ എങ്ങനെ അറിയിക്കും?",
         optionValues: [
            {
              option_value: "APP_SW",
              option_display: "ഞാൻ സ്വച്ഛത ആപ്പ് ഉപയോഗിക്കുന്നു"
            },
            {
              option_value: "APP_LOCAL",
              option_display: "ഞാൻ ഒരു ലോക്കൽ സിറ്റി ആപ്പ് ഉപയോഗിക്കുന്നു."
            },
            {
              option_value: "OTHER",
              option_display: "ഹെൽപ്പ്‌ലൈൻ നമ്പർ/പോർട്ടൽ, സോഷ്യൽ മീഡിയ തുടങ്ങിയ മറ്റ് മോഡുകളും ഞാൻ ഉപയോഗിക്കുന്നു."
            },
            {
              option_value: "NONE_EFFECTIVE",
              option_display: "ഒരു പരാതി പരിഹാര സംവിധാനവും ഫലപ്രദമായി പ്രവർത്തിക്കുന്നില്ല."
            },
            {
              option_value: "UNAWARE",
              option_display: "എനിക്ക് ഒരു പരാതി പരിഹാര സംവിധാനത്തെക്കുറിച്ച് അറിയില്ല."
            }
          ]
        }
      }
    },
    {
      questionDisplay: "How would you rate the city's response to your cleanliness-related complaints (e.g., garbage dumping, overflowing bins)?",
      optionType: "Single choice",
      optionValues: [
        {
          option_value: "5",
          option_display: "5 (The issue was addressed and resolved quickly.)"
        },
        {
          option_value: "4",
          option_display: "4 (The issue was resolved, but required follow-up)"
        },
        {
          option_value: "3",
          option_display: "3 (The issue was addressed but not resolved satisfactorily.)"
        },
        {
          option_value: "2",
          option_display: "2 (The complaint was acknowledged, but no action was taken.)"
        },
        {
          option_value: "1",
          option_display: "1 (The complaint was ignored or not registered.)"
        },
        {
          option_value: "NY",
          option_display: "I did not feel the need to report any issue"
        }
      ],
      questionCode: "FQ13",
      questionId: 13,
      questionDisplayOrder: 13,
      languages: {
       hi: {
          questionDisplay: "आप शहर की सफ़ाई से संबंधित शिकायतों (जैसे, कचरा फेंकना, कूड़ेदानों का ओवरफ्लो होना) पर प्रतिक्रिया को कैसे रेट करेंगे?",
          optionValues: [
            {
              option_value: "5",
              option_display: "5 (इस समस्या को जल्दी से सुलझा लिया गया)"
            },
            {
              option_value: "4",
              option_display: "4 (समस्या हल हो गई थी, लेकिन फ़ॉलो-अप की ज़रूरत थी)"
            },
            {
              option_value: "3",
              option_display: "3 (इस समस्‍या पर ध्यान दिया गया लेकिन इसे ठीक से हल नहीं किया गया)"
            },
            {
              option_value: "2",
              option_display: "2 (शिकायत तो मान ली गई, लेकिन कोई कार्रवाई नहीं की गई)"
            },
            {
              option_value: "1",
              option_display: "1 (शिकायत को नज़रअंदाज़ कर दिया गया या पंजीकृत नहीं किया गया)"
            },
            {
              option_value: "NY",
              option_display: "मुझे किसी भी समस्या को बताने की ज़रूरत महसूस नहीं हुई"
            }
          ]
        },
        "pa": {
          questionDisplay: "ਤੁਸੀਂ ਆਪਣੀਆਂ ਸਫ਼ਾਈ ਸੰਬੰਧੀ ਸ਼ਿਕਾਇਤਾਂ (ਜਿਵੇਂ ਕਿ ਕੂੜਾ ਸੁੱਟਣਾ, ਭਰੇ ਹੋਏ ਡੱਬੇ) ਪ੍ਰਤੀ ਸ਼ਹਿਰ ਦੇ ਜਵਾਬ ਨੂੰ ਕਿਵੇਂ ਦਰਜਾ ਦਿਓਗੇ?",
          optionValues: [
            {
              option_value: "5",
              option_display: "5 (ਮਸਲਾ ਸੰਬੋਧਨ ਕੀਤਾ ਗਿਆ ਅਤੇ ਤੁਰੰਤ ਹੱਲ ਕਰ ਦਿੱਤਾ ਗਿਆ।)"
            },
            {
              option_value: "4",
              option_display: "4 (ਮੁੱਦਾ ਹੱਲ ਹੋ ਗਿਆ ਸੀ, ਪਰ ਫਾਲੋ-ਅੱਪ ਦੀ ਲੋੜ ਸੀ)"
            },
            {
              option_value: "3",
              option_display: "3 (ਮਸਲਾ ਹੱਲ ਹੋ ਗਿਆ ਸੀ ਪਰ ਤਸੱਲੀਬਖਸ਼ ਹੱਲ ਨਹੀਂ ਹੋਇਆ।)"
            },
            {
              option_value: "2",
              option_display: "2 (ਸ਼ਿਕਾਇਤ ਨੂੰ ਸਵੀਕਾਰ ਕੀਤਾ ਗਿਆ ਸੀ, ਪਰ ਕੋਈ ਕਾਰਵਾਈ ਨਹੀਂ ਕੀਤੀ ਗਈ।)"
            },
            {
              option_value: "1",
              option_display: "1 (ਸ਼ਿਕਾਇਤ ਨੂੰ ਅਣਡਿੱਠਾ ਕਰ ਦਿੱਤਾ ਗਿਆ ਸੀ ਜਾਂ ਦਰਜ ਨਹੀਂ ਕੀਤਾ ਗਿਆ ਸੀ।)"
            },
            {
              option_value: "NY",
              option_display: "ਮੈਨੂੰ ਕਿਸੇ ਵੀ ਮੁੱਦੇ ਦੀ ਰਿਪੋਰਟ ਕਰਨ ਦੀ ਲੋੜ ਮਹਿਸੂਸ ਨਹੀਂ ਹੋਈ।"
            }
          ]
        },
       te: {
          questionDisplay: "పరిశుభ్రతకు సంబంధించిన మీ ఫిర్యాదుల పట్ల (ఉదా: చెత్త డంప్ చేయడం, డస్ట్ బిన్స్ నిండిపోవడం, శానిటేషన్ లోపం) నగర అధికారుల యొక్క రెస్పాన్స్ ని మీరు ఎలా అంచనా వేస్తారు?",
          optionValues: [
            {
              option_value: "5",
              option_display: "5 (సమస్యను త్వరగా పరిష్కరించారు.)"
            },
            {
              option_value: "4",
              option_display: "4 (సమస్యను పరిష్కరించారు, కానీ ఫాలో-అప్ అవసరమైంది.)"
            },
            {
              option_value: "3",
              option_display: "3 (సమస్యపై స్పందించారు, కానీ సంతృప్తికరంగా పరిష్కరించలేదు.)"
            },
            {
              option_value: "2",
              option_display: "2 (ఫిర్యాదును గుర్తించారు, కానీ ఎలాంటి చర్య తీసుకోలేదు.)"
            },
            {
              option_value: "1",
              option_display: "1 (ఫిర్యాదును పట్టించుకోలేదు లేదా నమోదు చేయలేదు.)"
            },
            {
              option_value: "NY",
              option_display: "నేను ఏ సమస్యను రిపోర్ట్ చేయాల్సిన అవసరం ఉందని భావించలేదు"
            }
          ]
        },
        as: {
          questionDisplay: "আপুনি আপোনাৰ পৰিষ্কাৰ-পৰিচ্ছন্নতা সম্পৰ্কীয় অভিযোগসমূহৰ প্ৰতি চহৰখনৰ সঁহাৰিৰ মূল্যায়ন কেনেকৈ কৰিব (যেনে, আৱৰ্জনা ডাম্পিং, উপচি পৰা বিন)?",
          optionValues: [
            {
              option_value: "5",
              option_display: "5 (সমস্যাটো সমাধান কৰা হৈছিল আৰু দ্ৰুতগতিত সমাধান কৰা হৈছিল)"
            },
            {
              option_value: "4",
              option_display: "4 (সমস্যাটো সমাধান কৰা হৈছিল, কিন্তু অনুসৰণৰ প্ৰয়োজন আছিল)"
            },
            {
              option_value: "3",
              option_display: "3 (সমস্যাটো সমাধান কৰা হৈছিল কিন্তু সন্তোষজনকভাৱে সমাধান কৰা হোৱা নাছিল)"
            },
            {
              option_value: "2",
              option_display: "2 (অভিযোগটো স্বীকাৰ কৰা হৈছিল যদিও কোনো ব্যৱস্থা লোৱা হোৱা নাছিল)"
            },
            {
              option_value: "1",
              option_display: "1 (অভিযোগটো উপেক্ষা কৰা হৈছিল বা পঞ্জীয়ন কৰা হোৱা নাছিল)"
            },
            {
              option_value: "NY",
              option_display: "মই কোনো সমস্যাৰ বিষয়ে অৱগত কৰাৰ প্ৰয়োজন অনুভৱ কৰা নাছিলো"
            }
          ]
        },
       or: {
          questionDisplay: "ଆପଣଙ୍କ ପରିଷ୍କାର ପରିଚ୍ଛନ୍ନତା ସମ୍ବନ୍ଧୀୟ ଅଭିଯୋଗଗୁଡ଼ିକ (ଯଥା, ଅଳିଆ ଆବର୍ଜନା, ଓଭରଫ୍ଳୋ ଡଷ୍ଟବିନ) ପ୍ରତି ସହରର ପ୍ରତିକ୍ରିୟାକୁ ଆପଣ କିପରି ମୂଲ୍ୟାଙ୍କନ କରିବେ?",
          optionValues: [
            {
              option_value: "5",
              option_display: "5 (ସମସ୍ୟାଟିର ସମାଧାନ କରାଯାଇଥିଲା ଏବଂ ଶୀଘ୍ର ସମାଧାନ କରାଯାଇଥିଲା।)"
            },
            {
              option_value: "4",
              option_display: "4 (ସମସ୍ୟାର ସମାଧାନ ହୋଇଥିଲା, କିନ୍ତୁ ଅନୁସରଣ ଆବଶ୍ୟକ ଥିଲା)"
            },
            {
              option_value: "3",
              option_display: "3 (ସମସ୍ୟାର ସମାଧାନ କରାଯାଇଥିଲା କିନ୍ତୁ ସନ୍ତୋଷଜନକ ଭାବରେ ସମାଧାନ ହୋଇନଥିଲା।)"
            },
            {
              option_value: "2",
              option_display: "2 (ଅଭିଯୋଗକୁ ସ୍ୱୀକାର କରାଯାଇଥିଲା, କିନ୍ତୁ କୌଣସି କାର୍ଯ୍ୟାନୁଷ୍ଠାନ ନିଆଯାଇନଥିଲା।)"
            },
            {
              option_value: "1",
              option_display: "1 (ଅଭିଯୋଗକୁ ଅଣଦେଖା କରାଯାଇଥିଲା କିମ୍ବା ପଞ୍ଜୀକୃତ କରାଯାଇ ନଥିଲା।)"
            },
            {
              option_value: "NY",
              option_display: "ମୁଁ କୌଣସି ସମସ୍ୟା ରିପୋର୍ଟ କରିବାର ଆବଶ୍ୟକତା ଅନୁଭବ କରିନଥିଲି।"
            }
          ]
        },
       mr: {
          questionDisplay: "स्वच्छतेशी संबंधित तुमच्या तक्रारींवर (उदा. कचरा साचणे, कचरा कुंड्या ओसंडून वाहणे) शहराच्या प्रशासनाकडून मिळणाऱ्या प्रतिसादाला तुम्ही कशी रेटिंग द्याल?",
          optionValues: [
            {
              option_value: "5",
              option_display: "5 (समस्येची दखल घेऊन ताबडतोब सोडवलेली.)"
            },
            {
              option_value: "4",
              option_display: "4 (समस्या सोडवलेली परंतु पाठपुरावा करावा लागलेला.)"
            },
            {
              option_value: "3",
              option_display: "3 (समस्येची दखल घेतलेली परंतु समाधानकारकरित्या सोडवली नव्हती.)"
            },
            {
              option_value: "2",
              option_display: "2 (तक्रारीची पोच मिळालेली, परंतु कोणतीही कार्यवाही झाली नाही.)"
            },
            {
              option_value: "1",
              option_display: "1 (तक्रारीकडे दुर्लक्ष करण्यात आलेले किंवा नोंदवली नाही.)"
            },
            {
              option_value: "NY",
              option_display: "मला कोणत्याही समस्येची तक्रार करण्याची गरज भासलेली नाही."
            }
          ]
        },
        ka: {
          questionDisplay: "ಸ್ವಚ್ಚತೆಯ ಸಂಬಂಧಿತ ನಿಮ್ಮ ದೂರುಗಳಿಗೆ ನಗರ ಪ್ರತಿಕ್ರಿಯೆಯನ್ನು ನೀವು ಹೇಗೆ ಅಂಕಿತಮಾಡುತ್ತೀರಿ?",
          optionValues: [
            {
              option_value: "5",
              option_display: "5 (ಸಮಸ್ಯೆಯನ್ನು ಗಮನಿಸಿ ತಕ್ಷಣ ಪರಿಹರಿಸಲಾಯಿತು)"
            },
            {
              option_value: "4",
              option_display: "4 (ಸಮಸ್ಯೆ ಪರಿಹರಿಸಲಾಯಿತು, ಆದರೆ ಫಾಲೋ-ಅಪ್ ಅಗತ್ಯವಿತ್ತು)"
            },
            {
              option_value: "3",
              option_display: "3 (ಸಮಸ್ಯೆಯನ್ನು ಗಮನಿಸಲಾಯಿತು, ಆದರೆ ತೃಪ್ತಿಕರವಾಗಿ ಪರಿಹರಿಸಲಿಲ್ಲ)"
            },
            {
              option_value: "2",
              option_display: "2 (ದೂರು ಸ್ವೀಕರಿಸಲಾಯಿತು, ಆದರೆ ಯಾವುದೇ ಕ್ರಮ ಕೈಗೊಳ್ಳಲಿಲ್ಲ)"
            },
            {
              option_value: "1",
              option_display: "1 (ದೂರುವನ್ನು ನಿರ್ಲಕ್ಷಿಸಲಾಗಿದೆ ಅಥವಾ ನೋಂದಾಯಿಸಲಿಲ್ಲ)"
            },
            {
              option_value: "NY",
              option_display: "ಯಾವುದೇ ಸಮಸ್ಯೆಯನ್ನು ವರದಿ ಮಾಡುವ ಅಗತ್ಯವಿದೆ ಎಂದು ನನಗೆ ಅನಿಸಲಿಲ್ಲ"
            }
          ]
        },
       bn: {
          questionDisplay: " আপনার পরিচ্ছন্নতা সংক্রান্ত অভিযোগগুলোর (যেমন- আবর্জনা জমা করে রাখা, বিন উপচে পড়া) প্রতি শহরের প্রতিক্রিয়াকে আপনি কিভাবে বিচার করবেন?",
          optionValues: [
            {
              option_value: "5",
              option_display: "5 (সমস্যাটি দ্রুত সমাধান করেছে)"
            },
            {
              option_value: "4",
              option_display: "4 (সমস্যাটির সমাধান হয়েছে কিন্তু ফলো-আপ করতে হয়েছে)"
            },
            {
              option_value: "3",
              option_display: "3 (সমস্যাটির ওপর কাজ করা হয়েছে কিন্তু সন্তোষজনকভাবে সমাধান করা হয়নি)"
            },
            {
              option_value: "2",
              option_display: "2 (অভিযোগের প্রাপ্তি স্বীকার করা হয়েছে, কিন্তু কোনো পদক্ষেপ নেওয়া হয়নি)"
            },
            {
              option_value: "1",
              option_display: "1 (অভিযোগ এড়িয়ে গেছিল রেজিস্টার করেনি)"
            },
            {
              option_value: "NY",
              option_display: " আমি কোনো সমস্যা জানানোর প্রয়োজন মনে করিনি"
            }
          ]
        },
        ta: {
          questionDisplay: "சுத்தம் தொடர்பான உங்கள் புகார்களுக்கு (எ.கா: குப்பை கொட்டுதல், குப்பைத் தொட்டிகள் நிரம்பி வழிதல்) நகர நிர்வாகம் அளித்த பதிலை நீங்கள் எவ்வாறு மதிப்பிடுவீர்கள்?",
          optionValues: [
            {
              option_value: "5",
              option_display: "5 (பிரச்சனை கவனிக்கப்பட்டது மேலும் விரைவாக தீர்வு காணப்பட்டது)"
            },
            {
              option_value: "4",
              option_display: "4 (பிரச்சனை தீர்க்கப்பட்டது, ஆனால் தொடர்ந்து ஃபாலோ செய்ய வேண்டியிருந்தது)"
            },
            {
              option_value: "3",
              option_display: "3 (பிரச்சனை கவனிக்கப்பட்டது ஆனால் திருப்திகரமாக தீர்வு காணப்படவில்லை.)"
            },
            {
              option_value: "2",
              option_display: "2 (புகார் ஏற்றுக்கொள்ளப்பட்டது, ஆனால் எந்த நடவடிக்கையும் எடுக்கப்படவில்லை.)"
            },
            {
              option_value: "1",
              option_display: "1 (புகார் புறக்கணிக்கப்பட்டது அல்லது பதிவு செய்யப்படவில்லை.)"
            },
            {
              option_value: "NY",
              option_display: "எந்தப் பிரச்சனையையும் புகாரளிக்க வேண்டிய அவசியத்தை நான் உணரவில்லை."
            }
          ]
        },
       ur: {
          questionDisplay: "آپ صفائی سے متعلق اپنی شکایات (جیسے کچرا پھینکنا، بھرے ہوئے ڈبے) پر شہر کے ردِعمل کو کیسے درجہ دیں گے؟",
          optionValues: [
            {
              option_value: "5",
              option_display: "۵ ( مسئلے کو فوری طور پر حل کر دیا گیا۔)"
            },
            {
              option_value: "4",
              option_display: "۴ (. مسئلہ حل ہو گیا، لیکن اس کے لیے مزید پیروی (فالو اپ) کی ضرورت پڑی۔)"
            },
            {
              option_value: "3",
              option_display: "۳ (. مسئلے پر توجہ دی گئی، لیکن اسے تسلی بخش طور پر حل نہیں کیا گیا۔)"
            },
            {
              option_value: "2",
              option_display: "۲ ( شکایت کو تسلیم کیا گیا، لیکن کوئی کارروائی نہیں کی گئی۔)"
            },
            {
              option_value: "1",
              option_display: "۱ (. شکایت کو نظر انداز کر دیا گیا یا درج ہی نہیں کیا گیا۔)"
            },
            {
              option_value: "NY",
              option_display: "مجھے کسی مسئلے کی اطلاع دینے کی ضرورت محسوس نہیں ہوئی"
            }
          ]
        },
       gu: {
          questionDisplay: "સ્વચ્છતા સંબંધિત તમારી ફરિયાદો (દા.ત., કચરો ફેંકવો, ભરાયેલા ડબ્બા) પર શહેરના/સીટી રિસ્પોન્સને તમે કેવી રીતે રેટ કરશો?",
          optionValues: [
            {
              option_value: "5",
              option_display: "5 (આ સમસ્યા પર ધ્યાન આપવામાં આવ્યું અને ઝડપથી તેનું નિરાકરણ કરવામાં આવ્યું)"
            },
            {
              option_value: "4",
              option_display: "4 (સમસ્યાનું નિરાકરણ થઇ ગયું છે, પણ ફોલોઅપ જરૂરી હતું)"
            },
            {
              option_value: "3",
              option_display: "3 (આ સમસ્યા પર ધ્યાન આપવામાં આવ્યું પણ તેનું સંતોષકારક રીતે નિરાકરણ કરવામાં આવ્યું નહોતું)"
            },
            {
              option_value: "2",
              option_display: "2 (ફરિયાદ સ્વીકારવામાં આવી હતી, પરંતુ કોઈ કાર્યવાહી કરવામાં આવી ન હતી.)"
            },
            {
              option_value: "1",
              option_display: "1 (ફરિયાદ પર ધ્યાન આપવામાં આવ્યું નહોતું અથવા નોંધવામાં આવી ન હતી.)"
            },
            {
              option_value: "NY",
              option_display: "મને કોઈપણ સમસ્યાની જાણ કરવાની જરૂર લાગી નથી."
            }
          ]
        },
       ml: {
          questionDisplay: "ശുചിത്വവുമായി ബന്ധപ്പെട്ട നിങ്ങളുടെ പരാതികളോടുള്ള (ഉദാ: മാലിന്യം തള്ളൽ, നിറഞ്ഞുകവിഞ്ഞ ബിന്നുകൾ) നഗരത്തിന്റെ പ്രതികരണത്തെ നിങ്ങൾ എങ്ങനെ വിലയിരുത്തുന്നു?",
          optionValues: [
            {
              option_value: "5",
              option_display: "5 (പ്രശ്നം പരിഗണിക്കുകയും  വേഗത്തിൽ പരിഹരിക്കുകയും ചെയ്തു.)"
            },
            {
              option_value: "4",
              option_display: "4 (പ്രശ്നം പരിഹരിച്ചു, പക്ഷേ തുടർനടപടികൾ ആവശ്യമായിരുന്നു)"
            },
            {
              option_value: "3",
              option_display: "3 (പ്രശ്നം പരിഹരിച്ചു, പക്ഷേ തൃപ്തികരമായി പരിഹരിച്ചില്ല.)"
            },
            {
              option_value: "2",
              option_display: "2 (പരാതി സ്വീകരിച്ചു, പക്ഷേ നടപടിയൊന്നും സ്വീകരിച്ചില്ല.)"
            },
            {
              option_value: "1",
              option_display: "1 (പരാതി അവഗണിക്കുകയോ രജിസ്റ്റർ ചെയ്യുകയോ ചെയ്തില്ല.)"
            },
            {
              option_value: "NY",
              option_display: "ഒരു പ്രശ്നവും റിപ്പോർട്ട് ചെയ്യേണ്ട ആവശ്യം എനിക്കുണ്ടായിരുന്നില്ല."
            }
          ]
        }
      }
    }
  ]
}
export default data;
